// Spinfix-b2 publish 2026-10-02 — Yusuf GO via Samson. Wrangler JL 2018–2023 / Gladiator 2025+ / Pajero Sport 2015–2019 / Puma 2020+ ACTIVE; finder year-band remaps + VIP 169. Megas untouched. HOLDs untouched.
// Plateinvert-8 publish 2026-10-01 — Yusuf GO via Samson. Outlander/Kluger XU70+XU40/Yaris XP210/NX AZ10+AZ20/Navara D23 2015–2020/C-HR AX10 ACTIVE; finder year-band remaps + VIP 169. HOLDs untouched.
// Cruze JH/JG + Focus LW/LZ/SA + Yaris XP130 2011–14/SII/SIII year-split publish 2026-10-01 — Yusuf GO via Samson. Megas DRAFT+301; finder year-banded; VIP 169.
// Roar vehicle finder — expanded 2026-09-24 19:12 AEST
// Finder link targets: Yusuf via Samson 2026-09-26 — every TC key now points only at ACTIVE + Online Store + HTTP 200 pages with the TROS-correct plug; dead/wrong-plug keys removed. See tc-pdp-qa/finder-link-fix-2026-09-26.md.
// Mitsubishi Triton (plug 601): Yusuf 3-page split via Samson — MQ 2016–2018 / MR 2019–2023 / MV 2024 onwards. 2026-09-26.
// Chevrolet Silverado 1500: Yusuf LOCK via Samson — year split 2019–2022 (T1) / 2023 onwards (MY23 GMSV Mar 2023+). Plug 715 both bands. 2026-09-24.
// Performance = full stocked-plug TC shelf (facelift matrix v2). roar4x4 = 4WD-weighted.
// Plugs allowlisted: 151, 510, 567, 601, 609, 715, 801, 830, 831, T63. Excluded DRAFT-only: 221, 571.
// Corolla E210: Yusuf LOCKED photo-purity split 2018–2022 / 2023 onwards (MY23 subtle — override of prior keep-single). Plug 830 both bands.
// No new PDPs this pass; handles resolve to existing ACTIVE catalogue only.

// Roar 4x4 Unified Vehicle Finder
// Three modes: Text Search, Photo AI, Dropdown Browse
(function() {
'use strict';

// AI Proxy URL — Cloudflare Worker that proxies to Anthropic API
var AI_PROXY_URL = 'https://roar4x4-ai-proxy.yusuf-4ff.workers.dev';

// ═══════════════════════════════════════════════════════════════
// VEHICLE DATABASE - TC handles mapped by Make|Model key
// ═══════════════════════════════════════════════════════════════
var TC_HANDLES_PERF = {
  "Audi|A1 (2010–2013)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A3 (1999–2004)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A4 (2001–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A6 (2004–2011)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A8 (2002–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|Q7 (2007–2015)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|Rs6 (2008–2010)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|S4 (2001–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|S8 D3 (2002–2010)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|Tt Mk1 (1998–2006)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Bentley|Brooklands (2008 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Bentley|Continental (2003–2004)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Bentley|Continental gt (2004–2011)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Chevrolet|Colorado RG-twin (2012–2016)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Colorado RG-twin facelift (2017–2022)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Cruze JG (2009–2011)": ["throttle-controller-holden-cruze-jg-2009-2011"],
  "Chevrolet|Cruze JH (2011–2016)": ["throttle-controller-holden-cruze-jh-2011-2016"],
  "Chevrolet|Hhr (2006–2011)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Malibu (2008–2018)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Orlando (2011–2018)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Sail (2001–2014)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Tornado (2011 onwards)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Trailblazer (2012 onwards)": ["roar-4x4-throttle-controller-holden-trailblazer"],
  "Dacia|Duster (2009 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Dacia|Logan (2004 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Dacia|Sandero (2007 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Daihatsu|AYLA (2017 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Daihatsu|HIJET TRUCK (2014 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Daihatsu|ROCKY (2021 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Daihatsu|SIGRA (2016 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Daihatsu|TERRIOS (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Daihatsu|XENIA (2015 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Datsun|GO (2014 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Dodge|DART (2013 onwards)": ["roar-4x4-throttle-controller-dodge-ram-1500"],
  "Dodge|RAM 1500 (2019 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM 1500 TRX (2021 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster 1500 (2014 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster 2500 (2014 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster 3500 (2014 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster City (2015 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Ford|Bronco (2020 onwards)": ["roar-4x4-throttle-controller-ford-bronco"],
  "Ford|C-Max (2011 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Edge (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Endura (2018–2019)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Escape (2013 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Escort (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Everest Next-Gen (2022 onwards)": ["roar-4x4-throttle-controller-ford-everest-nextgen"],
  "Ford|Everest Raptor Next-Gen (2022 onwards)": ["roar-4x4-throttle-controller-ford-everest-raptor-nextgen"],
  "Ford|Everest UA (2016–2018)": ["throttle-controller-ford-everest-ua-2016-2022"],
  "Ford|Everest UA II (2018–2022)": ["throttle-controller-ford-everest-ua-2016-2022"],
  "Ford|Explorer (2011 onwards)": ["roar-4x4-throttle-controller-ford-explorer"],
  "Ford|F-150 RAPTOR (2017 onwards)": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|F-150 SVT RAPTOR (2010–2014)": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|F150 (2009 onwards)": ["roar-4x4-throttle-controller-ford-f-150"],
  "Ford|F250 (2010 onwards)": ["roar-4x4-throttle-controller-ford-f250"],
  "Ford|F350 (2010 onwards)": ["roar-4x4-throttle-controller-ford-f350"],
  "Ford|Focus LW (2011–2015)": ["throttle-controller-ford-focus-lw-2011-2015"],
  "Ford|Focus LZ (2015–2018)": ["throttle-controller-ford-focus-lz-2015-2018"],
  "Ford|Focus SA (2018–2022)": ["throttle-controller-ford-focus-sa-2018-2022"],
  "Ford|Ftruck (2009 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|FUSION (2011 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|GRAND C-MAX (2010 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Kuga (2012 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Maverick (2022 onwards)": ["roar-4x4-throttle-controller-ford-maverick"],
  "Ford|Mondeo (2014 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Mustang (2011 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|PUMA (2019 onwards)": ["throttle-controller-ford-puma-2020-onwards"],
  "Ford|Puma (2020 onwards)": ["throttle-controller-ford-puma-2020-onwards"],

  "Ford|Ranger Next-Gen (2022 onwards)": ["roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Ford|Ranger PX1 (2012–2015)": ["roar-4x4-throttle-controller-ford-ranger-px1"],
  "Ford|Ranger PX2 (2016–2018)": ["roar-4x4-throttle-controller-ford-ranger-px2"],
  "Ford|Ranger PX3 (2019–2021)": ["roar-4x4-throttle-controller-ford-ranger-px3"],
  "Ford|Ranger raptor Next-Gen Raptor (2022 onwards)": ["roar-4x4-throttle-controller-ford-raptor-nextgen"],
  "Ford|Ranger raptor PX3 Raptor (2018–2021)": ["roar-4x4-throttle-controller-ford-raptor-px3"],
  "Ford|raptor (F150) (2011–2017)": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|S-Max (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Transit (2013 onwards)": ["roar-4x4-throttle-controller-ford-transit"],
  "Gmc|Canyon (2014–2022)": ["roar-4x4-throttle-controller-gmc-canyon"],
  "Great Wall|C20 (2012–2014)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|C30 (2010–2016)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|C50 (2012–2016)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|CANNON Cannon gen1 (2020–2023)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|CANNON Cannon refresh (2024 onwards)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|COOLBEAR (2010–2015)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|FLORID (2009–2013)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|H2 (2014 onwards)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|H6 (2011 onwards)": ["roar-4x4-throttle-controller-haval-h6"],
  "Great Wall|H8 (2013–2018)": ["roar-4x4-throttle-controller-haval-h8"],
  "Great Wall|H9 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Great Wall|LINGAO (all years)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|M2 (2012 onwards)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|M4 (2012 onwards)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|V80 (2007–2015)": ["roar-4x4-throttle-controller-ldv-v80"],
  "GWM|C20 (2012–2014)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|C30 (2010–2016)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|C50 (2012–2016)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|CANNON Cannon gen1 (2020–2023)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|CANNON Cannon refresh (2024 onwards)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|COOLBEAR (2010–2015)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|FLORID (2009–2013)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|H2 (all years)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|H6 (2011 onwards)": ["roar-4x4-throttle-controller-haval-h6"],
  "GWM|H8 (2013 onwards)": ["roar-4x4-throttle-controller-haval-h8"],
  "GWM|H9 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "GWM|LINGAO (all years)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|M2 (2012 onwards)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|M4 (2012 onwards)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|Tank 300 (2021 onwards)": ["throttle-controller-suits-gwm-tank-300-2022-current"],
  "GWM|V80 (2007–2015)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Haval|C20 (2012–2014)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|C30 (2010–2016)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|C50 (2012–2016)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|COOLBEAR (2010–2015)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|FLORID (2009–2013)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|H6 (2011 onwards)": ["roar-4x4-throttle-controller-haval-h6"],
  "Haval|H8 (2013 onwards)": ["roar-4x4-throttle-controller-haval-h8"],
  "Haval|H9 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|Jolion (2020 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|LINGAO (all years)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|M2 (2012 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|M4 (2012 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|V80 (2007–2015)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Hino|300 SERIES (2011 onwards)": ["roar-4x4-throttle-controller-hino-300-series"],
  "Holden|Colorado RG (2012–2016)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Colorado RG Series II (2017–2020)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Trailblazer (2012 onwards)": ["roar-4x4-throttle-controller-holden-trailblazer"],
  "Hummer|H3 (2006–2010)": ["roar-4x4-throttle-controller-hummer-h3"],
  "Isuzu|D-Max 3rd gen (2021–2024)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max 3rd gen facelift (2024 onwards)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max RT early (2012–2016)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max RT facelift (2017–2020)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|Mux 2nd gen (2021–2025)": ["throttle-controller-isuzu-mu-x-2021-2025"],
  "Isuzu|Mux 2nd gen facelift (2025 onwards)": ["throttle-controller-isuzu-mu-x-2025-onwards"],
  "Isuzu|Mux RF early (2013–2016)": ["throttle-controller-isuzu-mu-x-2013-2016"],
  "Isuzu|Mux RF Series II (2017–2020)": ["throttle-controller-isuzu-mu-x-2017-2020"],
  "Jaguar|Xe (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Jaguar|XF X260 (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Jeep|Cherokee (2014 onwards)": ["roar-4x4-throttle-controller-jeep-cherokee-kl"],
  "Jeep|Compass (2017 onwards)": ["roar-4x4-throttle-controller-jeep-compass"],
  "Jeep|GLADIATOR JT (2020–2024)": ["roar-4x4-throttle-controller-jeep-gladiator"],
  "Jeep|GLADIATOR JT (2025 onwards)": ["throttle-controller-jeep-gladiator-2025-onwards"],
  "Jeep|Grand cherokee (2022 onwards)": ["throttle-controller-suits-jeep-grand-cherokee-wl-2022-current-6-modes-plug-and-play"],
  "Jeep|RENEGADE (2014 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Jeep|Wrangler JL (2018–2023)": ["throttle-controller-jeep-wrangler-jl-2018-2023"],
  "Jeep|Wrangler JL (2024 onwards)": ["roar-4x4-throttle-controller-jeep-wrangler-jl"],
  "Jeep|Wrangler JT GLADIATOR (2020–2024)": ["roar-4x4-throttle-controller-jeep-gladiator"],
  "Jeep|Wrangler JT GLADIATOR (2025 onwards)": ["throttle-controller-jeep-gladiator-2025-onwards"],
  "Land Rover|Defender (2019 onwards)": ["roar-4x4-throttle-controller-land-rover-defender"],
  "Land Rover|Discovery 5 (2017 onwards)": ["roar-4x4-throttle-controller-land-rover-discovery-5"],
  "Land Rover|Discovery sport (2014 onwards)": ["roar-4x4-throttle-controller-land-rover-discovery-sport"],
  "Land Rover|Evoque (2016 onwards)": ["roar-4x4-throttle-controller-land-rover-evoque"],
  "Land Rover|Range Rover 4Th Gen (2012 onwards)": ["roar-4x4-throttle-controller-land-rover-range-rover"],
  "Land Rover|Range rover sport (2015 onwards)": ["roar-4x4-throttle-controller-land-rover-range-rover-sport"],
  "Land Rover|RANGE ROVER VELAR (2017 onwards)": ["roar-4x4-throttle-controller-land-rover-range-rover-velar"],
  "LDV|G10 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "LDV|MIFA (2022 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "LDV|V80 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Lexus|450D (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|CT200H (2011–2021)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es200 (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es200H (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es240 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es250 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es300 (2002–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Lexus|Es300H (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es350 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS F (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS L10 (2011 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS250 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS350 Grl10 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS430 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS450H (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX400 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX460 (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX470 (2003–2009)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GX550H (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|IS F (2007–2014)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|IS200D (2010–2012)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|IS200T (2015–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is220 (2005 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is220D (2006–2010)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is250 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is300 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is300H (2013 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is350 (2005 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is500F (2021 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LC 500 (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LC 500H (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Lm (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LM 350 (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LM 350H (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LM 500H (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS F (2008–2013)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Ls430 (2001–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Lexus|LS460 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS500 (2017 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS500H (2017 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS600H (2007–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Lx500D (2022 onwards)": ["roar-4x4-throttle-controller-lexus-lx500d"],
  "Lexus|Lx570 (2008 onwards)": ["roar-4x4-throttle-controller-lexus-lx570"],
  "Lexus|NX200 (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX200T (2015–2021)": ["throttle-controller-lexus-nx-az10-2017-2022"],
  "Lexus|NX300H (2014–2021)": ["throttle-controller-lexus-nx-az10-2017-2022"],
  "Lexus|NX350 (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX350H (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX450+ (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX AZ20 (2022 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],

  "Lexus|NX AZ10 (2017–2022)": ["throttle-controller-lexus-nx-az10-2017-2022"],

  "Lexus|RC F (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|RC200T (2016–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rc300 (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rc300H (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rc350 (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx Al10 (2008–2015)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx Al20 (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx200T (2015–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx270 (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx300 (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx350 (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx350H (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx450H (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx450H+ (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|RZ 300E (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|RZ 450E (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Sc430 (2001–2010)": ["roar-4x4-throttle-controller-plug-831"],
  "Lexus|TX350 (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|TX550H+ (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|UX 200 (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|UX 250H (2020 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|UX 300H (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lincoln|AVIATOR (2020 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|CORSAIR (2020 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|MKC (2015–2019)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|MKX (2016–2018)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|MKZ (2013–2020)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|NAUTILUS (2019 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|NAVIGATOR (2018 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Lincoln|Z (2022 onwards)": ["roar-4x4-throttle-controller-mazda-bt-50-up-ur"],
  "Maxus|eG10 (2016 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Maxus|G10 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Maxus|V80 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Mazda|Biante (2013–2018)": ["roar-4x4-throttle-controller-mazda-bt-50-up-ur"],
  "Mazda|Bt-50 TF / D-Max twin (2020–2024)": ["throttle-controller-mazda-bt-50-tf-2020-2024"],
  "Mazda|Bt-50 TF facelift (2025 onwards)": ["throttle-controller-mazda-bt-50-tf-2025-onwards"],
  "Mazda|Bt-50 UP (2012–2015)": ["throttle-controller-mazda-bt-50-up-2012-2015"],
  "Mazda|Bt-50 UR (2016–2019)": ["throttle-controller-mazda-bt-50-ur-2015-2019"],
  "Mercedes-Benz|X-Class (2018 onwards)": ["roar-4x4-throttle-controller-mercedes-benz-x-class"],
  "Mitsubishi|Asx (2024 onwards)": ["roar-4x4-throttle-controller-mitsubishi-asx"],
  "Mitsubishi|ATTRAGE (2015 onwards)": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018"],
  "Mitsubishi|COLT (2002–2013)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Mitsubishi|COLT (2023 onwards)": ["roar-4x4-throttle-controller-mitsubishi-asx"],
  "Mitsubishi|EXPRESS (2020 onwards)": ["roar-4x4-throttle-controller-mitsubishi-express"],
  "Mitsubishi|Mirage (2012–2016)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Mitsubishi|Mirage (2017 onwards)": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018"],
  "Mitsubishi|Montero (2006 onwards)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Mitsubishi|Pajero NS/NT (2006–2011)": ["mitsubishi-pajero-v80-2006-current-throttle-controller-plug-and-play-instant-pedal-response"],
  "Mitsubishi|Pajero NW/NX (2011–2021)": ["roar-4x4-throttle-controller-mitsubishi-pajero-nx"],
  "Mitsubishi|Pajero Sport": ["throttle-controller-mitsubishi-pajero-sport-2015-2019"],
  "Mitsubishi|Pajero sport QE (2015–2019)": ["throttle-controller-mitsubishi-pajero-sport-2015-2019"],
  "Mitsubishi|Pajero sport QE facelift / QF (2020 onwards)": ["roar-4x4-throttle-controller-mitsubishi-pajero-sport"],
  "Mitsubishi|Triton ML (2005–2009)": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Triton MN (2009–2015)": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Triton MQ (2016–2018)": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018"],
  "Mitsubishi|Triton MR (2019–2023)": ["roar-4x4-throttle-controller-mitsubishi-triton-2019-2023"],
  "Mitsubishi|Triton MV (2024 onwards)": ["roar-4x4-throttle-controller-mitsubishi-triton-2024-onwards"],
  "Mitsubishi|Xpander (2017 onwards)": ["roar-4x4-throttle-controller-mitsubishi-xpander"],
  "Nissan|Almera (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Altima (2006 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Caravan (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Cube Z11 (2005)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Dualis (2006–2014)": ["roar-4x4-throttle-controller-nissan-dualis"],
  "Nissan|E25 (2001–2012)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|ELGRAND E52 (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Frontier (2004 onwards)": ["roar-4x4-throttle-controller-nissan-terra"],
  "Nissan|Geniss (2006–2019)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|GT-R (2007 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|JUKE (2011 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|KICKS (2016 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Lannia (2015 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Latio (2012–2019)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Leaf (2011 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Livina (2006–2019)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Livina (2020 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Nissan|March (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Maxima (2004–2014)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Micra (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Murano (2009 onwards)": ["roar-4x4-throttle-controller-nissan-murano"],
  "Nissan|MX6 (2009 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Navara D40 early (2005–2009)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Navara D40 Series II (2010–2015)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Note (2004 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|NV200 (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|NV350 (all years)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Pathfinder (2013 onwards)": ["roar-4x4-throttle-controller-nissan-pathfinder-r52"],
  "Nissan|Patrol Y61 GU 3.0L CRD (2007–2016)": ["throttle-controller-nissan-patrol-y61-gu-crd-2007-2016"],
  "Nissan|Patrol Y62 (2013–2019)": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Patrol Y62 Series 5+ (2019 onwards)": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Prarie (1998–2004)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Pulsar (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Qashqai (2006 onwards)": ["roar-4x4-throttle-controller-nissan-qashqai"],
  "Nissan|Sentra (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Sunny (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Sylphy (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Teana J31 (2003–2008)": ["roar-4x4-throttle-controller-nissan-terra"],
  "Nissan|Teana J32 (2008–2013)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Terra (2018 onwards)": ["roar-4x4-throttle-controller-nissan-terra"],
  "Nissan|Tiida C11/C12/C13 (2004 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Titan A61 (2016 onwards)": ["roar-4x4-throttle-controller-nissan-titan"],
  "Nissan|Titan xd (2016 onwards)": ["roar-4x4-throttle-controller-nissan-titan"],
  "Nissan|Townstar (2022 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Townstar E-Tech (2024 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Urvan (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|VENUCIA (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Versa (2006 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Versa Note (2013 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|X-Trail T32 (2014 onwards)": ["roar-4x4-throttle-controller-nissan-x-trail-t32"],
  "Nissan|Xterra (2005–2015)": ["roar-4x4-throttle-controller-nissan-xterra"],
  "Opel/Vauxhall|GT (2007–2010)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Porsche|Cayenne (2002 onwards)": ["roar-4x4-throttle-controller-porsche-cayenne"],
  "Proton|PERODUA AXIA (all years)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Renault|Arkana (2020 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Captur (2013 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|CLio III / iv / v (2005 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Espace (2004 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Kangoo (2020 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Kangoo E-Tech (2022 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Koleos (2007 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Laguna III (2007–2015)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|LATITUDE (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Master (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Megane (2002 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Scenic (2003 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Talisman (2015 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|TRAFIC (2020 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Scion|Ia (2013 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Scion|Im (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Scion|Iq (2011–2016)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Scion|Tc (2005–2016)": ["roar-4x4-throttle-controller-plug-831"],
  "Scion|Xb (2007–2015)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Scion|Xd (2007–2014)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Seat|Alhambra (2000–2010)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Seat|Cordoba (2002–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Seat|Exeo (2008–2013)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Seat|Ibiza (2002–2017)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Seat|Leon (1998–2005)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Seat|Toledo (1998–2004)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Skoda|Fabia (1999–2014)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Skoda|Octavia (2000–2010)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Skoda|Superb (2001–2008)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Suzuki|Alivio (2014 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Carry (2013 onwards)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Suzuki|Ciaz (2014 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Ertiga (2012–2018)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Grand vitara (2005 onwards)": ["roar-4x4-throttle-controller-suzuki-grand-vitara"],
  "Suzuki|KIZASHI (2013)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Suzuki|LIANA (2005 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|S-CROSS (2013 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Solio (2008 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|SPLASH (2008 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Swift (2004–2017)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Swift Sport (2012–2018)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Sx4 (2006 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Vitara (2005 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Toyota|4Runner N210 (2002–2009)": ["roar-4x4-throttle-controller-toyota-4runner-n210"],
  "Toyota|4Runner N280 (2009 onwards)": ["roar-4x4-throttle-controller-toyota-4runner-n280"],
  "Toyota|AGYA (2013 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Alphard (2002–2008)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Alphard (2009 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Altis (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Aurion (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Auris (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|AVANZA (2012 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Avensis (2003–2008)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Avensis (2009–2018)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Axio (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Aygo (2015 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Aygo X (2022 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Belta (2006–2016)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Blade (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Camry Xv30 (2001–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Camry XV40 (2006–2009)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Camry XV40 (2009–2011)": ["throttle-controller-toyota-camry-xv40-2009-2011"],
  "Toyota|Camry XV50 (2011–2015)": ["throttle-controller-toyota-camry-xv50-2011-2015"],
  "Toyota|Camry XV50 (2015–2017)": ["throttle-controller-toyota-camry-xv50-2015-2017"],
  "Toyota|Camry XV70 (2017–2021)": ["throttle-controller-toyota-camry-xv70-2017-2021"],
  "Toyota|Camry XV70 (2021 onwards)": ["throttle-controller-toyota-camry-xv70-2021-2024"],
  "Toyota|Corolla E140/E150 (2007–2012)": ["throttle-controller-toyota-corolla-2007-2012"],
  "Toyota|Corolla E210 (2018–2022)": ["throttle-controller-toyota-corolla-2018-2022"],
  "Toyota|Corolla E210 (2023 onwards)": ["throttle-controller-toyota-corolla-2023-onwards"],
  "Toyota|Corolla (2018–2022)": ["throttle-controller-toyota-corolla-2018-2022"],
  "Toyota|Corolla (2023 onwards)": ["throttle-controller-toyota-corolla-2023-onwards"],
  "Toyota|Corolla Hatch E180 (2012–2018)": ["throttle-controller-toyota-corolla-hatch-2012-2018"],
  "Toyota|Corolla Sedan E170 (2014–2019)": ["throttle-controller-toyota-corolla-sedan-2014-2019"],
  "Toyota|Corolla Verso (2005–2008)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Corolla Verso (2009–2016)": ["throttle-controller-toyota-corolla-2007-2012"],
  "Toyota|Crown S200/S220/S210 (2008 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Estima (2000–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Estima Xr50 (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Fielder (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Fj cruiser (2006 onwards)": ["roar-4x4-throttle-controller-toyota-fj-cruiser"],
  "Toyota|Fortuner AN150/AN160 (2015–2020)": ["roar-4x4-throttle-controller-toyota-fortuner-an150-an160"],
  "Toyota|Fortuner AN150/AN160 (2020 onwards)": ["roar-4x4-throttle-controller-toyota-fortuner-an150-an160"],
  "Toyota|Granvia (2019 onwards)": ["roar-4x4-throttle-controller-toyota-granvia"],
  "Toyota|HARRIER (2013 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Hiace H200 (2004–2019)": ["roar-4x4-throttle-controller-toyota-hiace-h200"],
  "Toyota|Hiace H300 (2019 onwards)": ["roar-4x4-throttle-controller-toyota-hiace-h300"],
  "Toyota|HIGHLANDER (2007 onwards)": ["roar-4x4-throttle-controller-toyota-highlander"],
  "Toyota|Hilux N70 (2005–2011)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Hilux N70 (2011–2015)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Hilux N70-pre / 5-pin (2000–2004)": ["roar-4x4-throttle-controller-toyota-hilux-2000-2004-t63"],
  "Toyota|Hilux N80 (2015–2018)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2015-2018"],
  "Toyota|Hilux N80 (2018–2020)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2018-2020"],
  "Toyota|Hilux N80 (2020–2024)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2020-onwards"],
  "Toyota|Hilux N80 (2024 onwards)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2020-onwards"],
  "Toyota|Innova An140 (2015 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|IQ (2008 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Ist (2007–2016)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Land cruiser 100 SERIES V8 (2000 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-100-v8-831"],
  "Toyota|Land cruiser 100 SERIES with 5-pin pedal plug (2000 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-100-5pin-t63"],
  "Toyota|Land cruiser LC200 (2007–2012)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Land cruiser LC200 (2012–2015)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Land cruiser LC200 (2015–2021)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Land cruiser LC300 (2021 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-300"],
  "Toyota|Mark x X130 (2009–2019)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Matrix (2003–2008)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Matrix (2009–2014)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Noah (2014 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Picnic (2001–2009)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Prado J120 (2002–2006)": ["roar-4x4-throttle-controller-toyota-prado-j120"],
  "Toyota|Prado J120 (2006–2009)": ["roar-4x4-throttle-controller-toyota-prado-j120"],
  "Toyota|Prado J150 (2009–2013)": ["throttle-controller-toyota-prado-j150-2009-2013"],
  "Toyota|Prado J150 (2013–2015)": ["throttle-controller-toyota-prado-j150-2013-2017"],
  "Toyota|Prado J150 (2015–2017)": ["throttle-controller-toyota-prado-j150-2013-2017"],
  "Toyota|Prado J150 (2017–2021)": ["throttle-controller-toyota-prado-j150-2017-2021"],
  "Toyota|Prado J150 (2021–2023)": ["throttle-controller-toyota-prado-j150-2021-2023"],
  "Toyota|Previa (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Prius (2010 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Raize (2011 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA30 (2006–2008)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA30 (2008–2012)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA40 (2013–2015)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA40 (2015–2018)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA50 (2019 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rukus (2007–2015)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|RUSH (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Sequqia (2007 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Sienna (2010 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|SIENTA (2015 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Tarago (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Urban cruiser (2007–2016)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Vellfire (2008 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Verso (2009–2018)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Vios (2007 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Vitz (2005 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Voxy (2014 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Wish Ae10 (2003–2009)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Wish Ae20 (2010–2017)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Yaris XP130 (2011–2014)": ["throttle-controller-toyota-yaris-xp130-2011-2014"],
  "Toyota|Yaris XP130 Series II (2014–2017)": ["throttle-controller-toyota-yaris-xp130-series-ii-2014-2017"],
  "Toyota|Yaris XP130 Series III (2017–2020)": ["throttle-controller-toyota-yaris-xp130-series-iii-2017-2020"],
  "Toyota|Yaris XP210 (2020 onwards)": ["throttle-controller-toyota-yaris-xp210-2020-onwards"],
  "Toyota|C-HR AX10 (2019–2024)": ["throttle-controller-toyota-c-hr-ax10-2019-2024"],

  "Toyota|Yaris XP90 (2005–2008)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Yaris XP90 (2008–2011)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Volkswagen|Amarok 1st gen early (2011–2016)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Amarok 1st gen facelift (2016–2022)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Beetle (1998–2011)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Bora (1999–2005)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|FOX (2005 onwards)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Golf (1997–2003)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Jetta A5 (2006–2011)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Lavida 1St Gen (2008–2013)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Lupo (1998–2005)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Multivan (2023 onwards)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Passat B5/B5.5Typ 3B/3Bg (1997–2006)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Phaeton (2002–2006)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Polo Typ 6Q/9N/9N34Th Gen (2002–2009)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|SANTANA (2000–2012)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Sharan Mark1A/1B (2000–2010)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|T5 (2009–2015)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Volkswagen|T5 Multivan (2009–2015)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Volkswagen|T6 (2015 onwards)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Volkswagen|Touareg (2002–2018)": ["roar-4x4-throttle-controller-volkswagen-touareg"],
  "Volkswagen|Transporter (2009 onwards)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Ford|Falcon FG (2008–2014)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Ford|Falcon FG X (2014–2016)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Ford|Territory SZ (2011–2016)": ["roar-4x4-throttle-controller-ldv-g10"],
  "GWM|Tank 500 (2022 onwards)": ["throttle-controller-suits-gwm-tank-300-2022-current"],
  "Haval|H2 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h6"],
  "Alfa Romeo|159 (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Brera coupe (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Giulia (2016 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Giulietta (2010 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Mito (2008–2018)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|SPIDER (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|STELVIO (2017 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|500 (2007–2019)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|500X (2015 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|595 (2020 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|Abarth 500 (2007–2014)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|BRAVO (2011 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|DOBLO 3V 263 (2009 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|Ducato (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|Punto (2011–2018)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Holden|Astra Ah/Pj (1998–2016)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Commodore Ve (2006–2013)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Cruze JG (2009–2011)": ["throttle-controller-holden-cruze-jg-2009-2011"],
  "Holden|Cruze JH (2011–2016)": ["throttle-controller-holden-cruze-jh-2011-2016"],
  "Holden|MALIBU (2008–2016)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Statesman Wm (2006–2013)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Tigra (2002–2009)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Vectra C (2002–2008)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|ZAFIRA (2000 onwards)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Nissan|Navara D23/NP300 (2015–2020)": ["throttle-controller-nissan-navara-d23-2015-2020"],
  "Nissan|Navara D23 MY21 (2021 onwards)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Pathfinder (2005–2012)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Opel/Vauxhall|Astra H/J/G (2000–2015)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Opel/Vauxhall|Corsa (2000 onwards)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Opel/Vauxhall|Insignia (2008 onwards)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Saab|All Models (2005–2011)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Smart|FORFOUR (up to 2007)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Lexus|GS S190 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS 30/35/43/460 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS300 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS350 GRS191 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS430 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS450H (2007–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS460 (2008–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|Rx330 (2004–2006)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|Rx350 (2004–2009)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|Rx400H (2005–2009)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Suzuki|Swift Sport (2005–2011)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Kluger (2000–2007)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Land cruiser 70 Series (VDJ76/78/79) (2007–2009)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Prius (2004–2009)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Mitsubishi|Challenger (2008–2016)": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Chevrolet|Silverado 2500HD (2020 onwards)": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022"],
  "Mazda|5 (2011 onwards)": ["roar-4x4-throttle-controller-mazda-bt-50-up-ur"],
  "Mazda|6 GH (2008–2012)": ["roar-4x4-throttle-controller-mazda-bt-50-up-ur"],
  "Volkswagen|Amarok (2023 onwards)": ["roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Mitsubishi|Outlander 4th gen (2022 onwards)": ["throttle-controller-mitsubishi-outlander-2022-onwards"],
  "Nissan|X-Trail T31 (2007–2013)": ["roar-4x4-throttle-controller-nissan-x-trail-t32"],
  "Lexus|Lx600 (2021 onwards)": ["roar-4x4-throttle-controller-lexus-lx570"],
  "Toyota|CH-R AX10 early (2016–2019)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|CH-R AX10 facelift (2019 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Kluger XU40 (2007–2010)": ["roar-4x4-throttle-controller-toyota-highlander"],
  "Toyota|Kluger XU40 (2010–2013)": ["throttle-controller-toyota-kluger-xu40-2010-2014"],
  "Toyota|Kluger XU50 (2014–2017)": ["throttle-controller-toyota-kluger-xu50-2014-2017"],
  "Toyota|Kluger XU50 (2017–2020)": ["throttle-controller-toyota-kluger-xu50-2017-2020"],
  "Toyota|Kluger XU70 (2021 onwards)": ["throttle-controller-toyota-kluger-xu70-2021-onwards"],
  "Toyota|Land cruiser 70 Series (VDJ76/78/79) (2009 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Prado 250 (2024 onwards)": ["roar-4x4-throttle-controller-toyota-prado-250"],
  "Toyota|Tundra (2007 onwards)": ["roar-4x4-throttle-controller-toyota-sequoia"],
  "Chevrolet|Silverado 1500 (2019–2022)": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022"],
  "Chevrolet|Silverado 1500 (2023 onwards)": ["roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards"]
};
var TC_HANDLES_4X4 = {
  "Audi|Q7 (2007–2015)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Chevrolet|Colorado RG-twin (2012–2016)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Colorado RG-twin facelift (2017–2022)": ["roar-4x4-throttle-controller-chevrolet-colorado"],
  "Chevrolet|Silverado": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022", "roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards"],
  "Chevrolet|Silverado 1500 (2019–2022)": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022"],
  "Chevrolet|Silverado 1500 (2023 onwards)": ["roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards"],
  "Chevrolet|Silverado (2019–2022)": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022"],
  "Chevrolet|Silverado (2023 onwards)": ["roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards"],
  "Chevrolet|Silverado 1500": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022", "roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards"],
  "Chevrolet|Trailblazer (2012 onwards)": ["roar-4x4-throttle-controller-holden-trailblazer"],
  "Dacia|Duster (2009 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Dodge|RAM": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM 1500": ["roar-4x4-throttle-controller-dodge-ram-1500"],
  "Dodge|RAM 1500 (2019 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM 1500 TRX": ["roar-4x4-throttle-controller-dodge-ram-1500-trx"],
  "Dodge|RAM 1500 TRX (2021 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster 1500 (2014 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster 2500 (2014 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster 3500 (2014 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Dodge|RAM ProMaster City (2015 onwards)": ["throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response"],
  "Ford|Bronco": ["roar-4x4-throttle-controller-ford-bronco"],
  "Ford|Bronco (2020 onwards)": ["roar-4x4-throttle-controller-ford-bronco"],
  "Ford|Edge (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Endura (2018–2019)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Escape (2013 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Everest": ["throttle-controller-ford-everest-ua-2016-2022", "roar-4x4-throttle-controller-ford-everest-nextgen"],
  "Ford|Everest 3rd Gen": ["throttle-controller-ford-everest-ua-2016-2022"],
  "Ford|Everest Next Gen": ["roar-4x4-throttle-controller-ford-everest-nextgen"],
  "Ford|Everest Next-Gen (2022 onwards)": ["roar-4x4-throttle-controller-ford-everest-nextgen"],
  "Ford|Everest Raptor": ["roar-4x4-throttle-controller-ford-everest-raptor-nextgen"],
  "Ford|Everest Raptor Next-Gen (2022 onwards)": ["roar-4x4-throttle-controller-ford-everest-raptor-nextgen"],
  "Ford|Everest UA": ["throttle-controller-ford-everest-ua-2016-2022"],
  "Ford|Everest UA (2016–2018)": ["throttle-controller-ford-everest-ua-2016-2022"],
  "Ford|Everest UA II (2018–2022)": ["throttle-controller-ford-everest-ua-2016-2022"],
  "Ford|Explorer": ["roar-4x4-throttle-controller-ford-explorer"],
  "Ford|Explorer (2011 onwards)": ["roar-4x4-throttle-controller-ford-explorer"],
  "Ford|F-150 Raptor": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|F-150 RAPTOR (2017 onwards)": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|F-150 SVT RAPTOR (2010–2014)": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|F150": ["roar-4x4-throttle-controller-ford-f-150"],
  "Ford|F150 (2009 onwards)": ["roar-4x4-throttle-controller-ford-f-150"],
  "Ford|F250": ["roar-4x4-throttle-controller-ford-f250"],
  "Ford|F250 (2010 onwards)": ["roar-4x4-throttle-controller-ford-f250"],
  "Ford|F350": ["roar-4x4-throttle-controller-ford-f350"],
  "Ford|F350 (2010 onwards)": ["roar-4x4-throttle-controller-ford-f350"],
  "Ford|Kuga (2012 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Maverick": ["roar-4x4-throttle-controller-ford-maverick"],
  "Ford|Maverick (2022 onwards)": ["roar-4x4-throttle-controller-ford-maverick"],
  "Ford|Ranger & Raptor": ["roar-4x4-throttle-controller-ford-ranger-px1", "roar-4x4-throttle-controller-ford-ranger-px2", "roar-4x4-throttle-controller-ford-ranger-px3", "roar-4x4-throttle-controller-ford-ranger-nextgen-t6", "roar-4x4-throttle-controller-ford-raptor-px3", "roar-4x4-throttle-controller-ford-raptor-nextgen"],
  "Ford|Ranger Next Gen": ["roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Ford|Ranger Next-Gen (2022 onwards)": ["roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Ford|Ranger NextGen T6": ["roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Ford|Ranger PX1": ["roar-4x4-throttle-controller-ford-ranger-px1"],
  "Ford|Ranger PX1 (2012–2015)": ["roar-4x4-throttle-controller-ford-ranger-px1"],
  "Ford|Ranger PX2": ["roar-4x4-throttle-controller-ford-ranger-px2"],
  "Ford|Ranger PX2 (2016–2018)": ["roar-4x4-throttle-controller-ford-ranger-px2"],
  "Ford|Ranger PX2 PX3": ["roar-4x4-throttle-controller-ford-ranger-px2", "roar-4x4-throttle-controller-ford-ranger-px3"],
  "Ford|Ranger PX3": ["roar-4x4-throttle-controller-ford-ranger-px3"],
  "Ford|Ranger PX3 (2019–2021)": ["roar-4x4-throttle-controller-ford-ranger-px3"],
  "Ford|Ranger PX3/PX4": ["roar-4x4-throttle-controller-ford-ranger-px3"],
  "Ford|Ranger Raptor": ["roar-4x4-throttle-controller-ford-raptor-px3", "roar-4x4-throttle-controller-ford-raptor-nextgen"],
  "Ford|Ranger raptor Next-Gen Raptor (2022 onwards)": ["roar-4x4-throttle-controller-ford-raptor-nextgen"],
  "Ford|Ranger raptor PX3 Raptor (2018–2021)": ["roar-4x4-throttle-controller-ford-raptor-px3"],
  "Ford|Raptor": ["throttle-controller-suits-next-gen-ford-raptor"],
  "Ford|raptor (F150) (2011–2017)": ["roar-4x4-throttle-controller-ford-f-150-raptor"],
  "Ford|Transit (2013 onwards)": ["roar-4x4-throttle-controller-ford-transit"],
  "GMC|Canyon": ["roar-4x4-throttle-controller-gmc-canyon"],
  "Gmc|Canyon (2014–2022)": ["roar-4x4-throttle-controller-gmc-canyon"],
  "Great Wall|CANNON Cannon gen1 (2020–2023)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|CANNON Cannon refresh (2024 onwards)": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "Great Wall|H8 (2013–2018)": ["roar-4x4-throttle-controller-haval-h8"],
  "Great Wall|H9 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Great Wall|V80 (2007–2015)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Greatwall|Cannon": ["roar-4x4-throttle-controller-greatwall-cannon"],
  "GWM|Cannon": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|CANNON Cannon gen1 (2020–2023)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|CANNON Cannon refresh (2024 onwards)": ["roar-4x4-throttle-controller-gwm-cannon"],
  "GWM|Cannon NPW": ["throttle-controller-suits-gwm-cannon-npw-2020-2024-instant-pedal-response"],
  "GWM|H8 (2013 onwards)": ["roar-4x4-throttle-controller-haval-h8"],
  "GWM|H9 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "GWM|Tank 300": ["throttle-controller-suits-gwm-tank-300-2022-current"],
  "GWM|Tank 300 (2021 onwards)": ["throttle-controller-suits-gwm-tank-300-2022-current"],
  "GWM|V80 (2007–2015)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Haval|H6": ["roar-4x4-throttle-controller-haval-h6"],
  "Haval|H8 (2013 onwards)": ["roar-4x4-throttle-controller-haval-h8"],
  "Haval|H9": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|H9 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h9"],
  "Haval|V80 (2007–2015)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Hino|300 Series": ["roar-4x4-throttle-controller-hino-300-series"],
  "Holden|Colorado": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Colorado RG (2012–2016)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Colorado RG Series II (2017–2020)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|RG Colorado": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Trailblazer": ["roar-4x4-throttle-controller-holden-trailblazer"],
  "Holden|Trailblazer (2012 onwards)": ["roar-4x4-throttle-controller-holden-trailblazer"],
  "Hummer|H3": ["roar-4x4-throttle-controller-hummer-h3"],
  "Ineos|Grenadier": ["roar-4x4-throttle-controller-ineos-grenadier"],
  "Isuzu|D-Max": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max 3rd gen (2021–2024)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max 3rd gen facelift (2024 onwards)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max RG": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max RT early (2012–2016)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max RT facelift (2017–2020)": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|D-Max TF": ["throttle-controller-isuzu-d-max-2012-onwards"],
  "Isuzu|MU-X": ["throttle-controller-isuzu-mu-x-2013-2016", "throttle-controller-isuzu-mu-x-2017-2020", "throttle-controller-isuzu-mu-x-2021-2025", "throttle-controller-isuzu-mu-x-2025-onwards"],
  "Isuzu|MU-X RF": ["throttle-controller-isuzu-mu-x-2013-2016", "throttle-controller-isuzu-mu-x-2017-2020"],
  "Isuzu|MU-X RJ": ["throttle-controller-isuzu-mu-x-2021-2025", "throttle-controller-isuzu-mu-x-2025-onwards"],
  "Isuzu|MUX": ["throttle-controller-isuzu-mu-x-2013-2016", "throttle-controller-isuzu-mu-x-2017-2020", "throttle-controller-isuzu-mu-x-2021-2025", "throttle-controller-isuzu-mu-x-2025-onwards"],
  "Isuzu|Mux 2nd gen (2021–2025)": ["throttle-controller-isuzu-mu-x-2021-2025"],
  "Isuzu|Mux 2nd gen facelift (2025 onwards)": ["throttle-controller-isuzu-mu-x-2025-onwards"],
  "Isuzu|Mux RF early (2013–2016)": ["throttle-controller-isuzu-mu-x-2013-2016"],
  "Isuzu|Mux RF Series II (2017–2020)": ["throttle-controller-isuzu-mu-x-2017-2020"],
  "Jaguar|Xe (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Jaguar|XF X260 (2015 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Jeep|Cherokee": ["roar-4x4-throttle-controller-jeep-cherokee-kl"],
  "Jeep|Cherokee (2014 onwards)": ["roar-4x4-throttle-controller-jeep-cherokee-kl"],
  "Jeep|Cherokee KL": ["roar-4x4-throttle-controller-jeep-cherokee-kl"],
  "Jeep|Compass": ["roar-4x4-throttle-controller-jeep-compass"],
  "Jeep|Compass (2017 onwards)": ["roar-4x4-throttle-controller-jeep-compass"],
  "Jeep|Gladiator": ["roar-4x4-throttle-controller-jeep-gladiator"],
  "Jeep|Gladiator JT": ["roar-4x4-throttle-controller-jeep-gladiator"],
  "Jeep|GLADIATOR JT (2020–2024)": ["roar-4x4-throttle-controller-jeep-gladiator"],
  "Jeep|GLADIATOR JT (2025 onwards)": ["throttle-controller-jeep-gladiator-2025-onwards"],
  "Jeep|Grand cherokee (2022 onwards)": ["throttle-controller-suits-jeep-grand-cherokee-wl-2022-current-6-modes-plug-and-play"],
  "Jeep|Grand Cherokee WL": ["throttle-controller-suits-jeep-grand-cherokee-wl-2022-current-6-modes-plug-and-play"],
  "Jeep|Renegade": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Jeep|RENEGADE (2014 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Jeep|Wrangler JL": ["roar-4x4-throttle-controller-jeep-wrangler-jl"],
  "Jeep|Wrangler JL (2018–2023)": ["throttle-controller-jeep-wrangler-jl-2018-2023"],
  "Jeep|Wrangler JL (2024 onwards)": ["roar-4x4-throttle-controller-jeep-wrangler-jl"],
  "Jeep|Wrangler JT GLADIATOR (2020–2024)": ["roar-4x4-throttle-controller-jeep-gladiator"],
  "Jeep|Wrangler JT GLADIATOR (2025 onwards)": ["throttle-controller-jeep-gladiator-2025-onwards"],
  "Land Rover|Defender": ["roar-4x4-throttle-controller-land-rover-defender"],
  "Land Rover|Defender (2019 onwards)": ["roar-4x4-throttle-controller-land-rover-defender"],
  "Land Rover|Defender 110": ["roar-4x4-throttle-controller-land-rover-defender"],
  "Land Rover|Defender 130": ["roar-4x4-throttle-controller-land-rover-defender-130"],
  "Land Rover|Discovery 5": ["roar-4x4-throttle-controller-land-rover-discovery-5"],
  "Land Rover|Discovery 5 (2017 onwards)": ["roar-4x4-throttle-controller-land-rover-discovery-5"],
  "Land Rover|Discovery Sport": ["roar-4x4-throttle-controller-land-rover-discovery-sport"],
  "Land Rover|Discovery sport (2014 onwards)": ["roar-4x4-throttle-controller-land-rover-discovery-sport"],
  "Land Rover|Evoque": ["roar-4x4-throttle-controller-land-rover-evoque"],
  "Land Rover|Range Rover": ["roar-4x4-throttle-controller-land-rover-range-rover"],
  "Land Rover|Range Rover 4Th Gen (2012 onwards)": ["roar-4x4-throttle-controller-land-rover-range-rover"],
  "Land Rover|Range Rover Sport": ["roar-4x4-throttle-controller-land-rover-range-rover-sport"],
  "Land Rover|Range rover sport (2015 onwards)": ["roar-4x4-throttle-controller-land-rover-range-rover-sport"],
  "Land Rover|Range Rover Velar": ["roar-4x4-throttle-controller-land-rover-range-rover-velar"],
  "Land Rover|RANGE ROVER VELAR (2017 onwards)": ["roar-4x4-throttle-controller-land-rover-range-rover-velar"],
  "LDV|G10 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "LDV|MIFA (2022 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "LDV|V80 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Lexus|GX 460": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX 470": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GX400 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX460": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX460 (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GX470 (2003–2009)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GX550H (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Lm (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LM 350 (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LM 350H (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LM 500H (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LX 570": ["roar-4x4-throttle-controller-lexus-lx570"],
  "Lexus|Lx500D (2022 onwards)": ["roar-4x4-throttle-controller-lexus-lx500d"],
  "Lexus|Lx570 (2008 onwards)": ["roar-4x4-throttle-controller-lexus-lx570"],
  "Lexus|NX200 (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX200T (2015–2021)": ["throttle-controller-lexus-nx-az10-2017-2022"],
  "Lexus|NX300H (2014–2021)": ["throttle-controller-lexus-nx-az10-2017-2022"],
  "Lexus|NX350 (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX350H (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX450+ (2021 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],
  "Lexus|NX AZ20 (2022 onwards)": ["throttle-controller-lexus-nx-az20-2022-onwards"],

  "Lexus|NX AZ10 (2017–2022)": ["throttle-controller-lexus-nx-az10-2017-2022"],

  "Lexus|Rx Al10 (2008–2015)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx Al20 (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx200T (2015–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx270 (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx300 (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx350 (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx350H (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx450H (2010 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rx450H+ (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|TX350 (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|TX550H+ (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Maxus|eG10 (2016 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Maxus|G10 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Maxus|V80 (2014 onwards)": ["roar-4x4-throttle-controller-ldv-v80"],
  "Mazda|BT-50": ["throttle-controller-mazda-bt-50-up-2012-2015", "throttle-controller-mazda-bt-50-ur-2015-2019", "throttle-controller-mazda-bt-50-tf-2020-2024", "throttle-controller-mazda-bt-50-tf-2025-onwards"],
  "Mazda|BT-50 TF": ["throttle-controller-mazda-bt-50-tf-2020-2024", "throttle-controller-mazda-bt-50-tf-2025-onwards"],
  "Mazda|Bt-50 TF / D-Max twin (2020–2024)": ["throttle-controller-mazda-bt-50-tf-2020-2024"],
  "Mazda|Bt-50 TF facelift (2025 onwards)": ["throttle-controller-mazda-bt-50-tf-2025-onwards"],
  "Mazda|Bt-50 UP (2012–2015)": ["throttle-controller-mazda-bt-50-up-2012-2015"],
  "Mazda|BT-50 UP/UR": ["throttle-controller-mazda-bt-50-up-2012-2015", "throttle-controller-mazda-bt-50-ur-2015-2019"],
  "Mazda|Bt-50 UR (2016–2019)": ["throttle-controller-mazda-bt-50-ur-2015-2019"],
  "Mercedes-Benz|X-Class": ["roar-4x4-throttle-controller-mercedes-benz-x-class"],
  "Mercedes-Benz|X-Class (2018 onwards)": ["roar-4x4-throttle-controller-mercedes-benz-x-class"],
  "Mitsubishi|ASX": ["roar-4x4-throttle-controller-mitsubishi-asx"],
  "Mitsubishi|Asx (2024 onwards)": ["roar-4x4-throttle-controller-mitsubishi-asx"],
  "Mitsubishi|EXPRESS (2020 onwards)": ["roar-4x4-throttle-controller-mitsubishi-express"],
  "Mitsubishi|Montero": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Mitsubishi|Montero (2006 onwards)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Mitsubishi|Pajero NS/NT (2006–2011)": ["mitsubishi-pajero-v80-2006-current-throttle-controller-plug-and-play-instant-pedal-response"],
  "Mitsubishi|Pajero NW/NX (2011–2021)": ["roar-4x4-throttle-controller-mitsubishi-pajero-nx"],
  "Mitsubishi|Pajero NX": ["roar-4x4-throttle-controller-mitsubishi-pajero-nx"],
  "Mitsubishi|Pajero Sport": ["throttle-controller-mitsubishi-pajero-sport-2015-2019"],
  "Mitsubishi|Pajero sport QE (2015–2019)": ["throttle-controller-mitsubishi-pajero-sport-2015-2019"],
  "Mitsubishi|Pajero sport QE facelift / QF (2020 onwards)": ["roar-4x4-throttle-controller-mitsubishi-pajero-sport"],
  "Mitsubishi|Pajero V80": ["mitsubishi-pajero-v80-2006-current-throttle-controller-plug-and-play-instant-pedal-response"],
  "Mitsubishi|Triton": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018", "roar-4x4-throttle-controller-mitsubishi-triton-2019-2023", "roar-4x4-throttle-controller-mitsubishi-triton-2024-onwards", "roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Triton ML (2005–2009)": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Triton ML/MN": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Triton MN (2009–2015)": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Triton MQ (2016–2018)": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018"],
  "Mitsubishi|Triton MQ/MR": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018", "roar-4x4-throttle-controller-mitsubishi-triton-2019-2023"],
  "Mitsubishi|Triton MR (2019–2023)": ["roar-4x4-throttle-controller-mitsubishi-triton-2019-2023"],
  "Mitsubishi|Triton MV": ["roar-4x4-throttle-controller-mitsubishi-triton-2024-onwards"],
  "Mitsubishi|Triton MV (2024 onwards)": ["roar-4x4-throttle-controller-mitsubishi-triton-2024-onwards"],
  "Mitsubishi|Xpander": ["roar-4x4-throttle-controller-mitsubishi-xpander"],
  "Nissan|Caravan (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Dualis (2006–2014)": ["roar-4x4-throttle-controller-nissan-dualis"],
  "Nissan|Frontier (2004 onwards)": ["roar-4x4-throttle-controller-nissan-terra"],
  "Nissan|Murano": ["roar-4x4-throttle-controller-nissan-murano"],
  "Nissan|Murano (2009 onwards)": ["roar-4x4-throttle-controller-nissan-murano"],
  "Nissan|Navara D40": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Navara D40 early (2005–2009)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Navara D40 Series II (2010–2015)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Navara D40 Spanish": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Navara D40 Thai": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|NV200 (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|NV350 (all years)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Pathfinder (2013 onwards)": ["roar-4x4-throttle-controller-nissan-pathfinder-r52"],
  "Nissan|Pathfinder R52": ["roar-4x4-throttle-controller-nissan-pathfinder-r52"],
  "Nissan|Patrol Y61 GU 3.0L CRD (2007–2016)": ["throttle-controller-nissan-patrol-y61-gu-crd-2007-2016"],
  "Nissan|Patrol Y62": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Patrol Y62 (2013–2019)": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Patrol Y62 Series 5+ (2019 onwards)": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Patrol Y62 ST-L/TI": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Patrol Y62 TI-LW": ["roar-4x4-throttle-controller-nissan-patrol-y62"],
  "Nissan|Qashqai (2006 onwards)": ["roar-4x4-throttle-controller-nissan-qashqai"],
  "Nissan|Terra": ["roar-4x4-throttle-controller-nissan-terra"],
  "Nissan|Terra (2018 onwards)": ["roar-4x4-throttle-controller-nissan-terra"],
  "Nissan|Titan": ["roar-4x4-throttle-controller-nissan-titan"],
  "Nissan|Titan A61 (2016 onwards)": ["roar-4x4-throttle-controller-nissan-titan"],
  "Nissan|Titan xd (2016 onwards)": ["roar-4x4-throttle-controller-nissan-titan"],
  "Nissan|Urvan (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|X-Trail T32": ["roar-4x4-throttle-controller-nissan-x-trail-t32"],
  "Nissan|X-Trail T32 (2014 onwards)": ["roar-4x4-throttle-controller-nissan-x-trail-t32"],
  "Nissan|Xterra": ["roar-4x4-throttle-controller-nissan-xterra"],
  "Nissan|Xterra (2005–2015)": ["roar-4x4-throttle-controller-nissan-xterra"],
  "Porsche|Cayenne": ["roar-4x4-throttle-controller-porsche-cayenne"],
  "Porsche|Cayenne (2002 onwards)": ["roar-4x4-throttle-controller-porsche-cayenne"],
  "RAM|1500 5.7L Hemi": ["roar-4x4-throttle-controller-dodge-ram-1500"],
  "Renault|Koleos (2007 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Master (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|TRAFIC (2020 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Suzuki|Grand Vitara": ["roar-4x4-throttle-controller-suzuki-grand-vitara"],
  "Suzuki|Grand vitara (2005 onwards)": ["roar-4x4-throttle-controller-suzuki-grand-vitara"],
  "Suzuki|S-CROSS (2013 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Sx4 (2006 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Vitara": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Vitara (2005 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Toyota|4Runner N210": ["roar-4x4-throttle-controller-toyota-4runner-n210"],
  "Toyota|4Runner N210 (2002–2009)": ["roar-4x4-throttle-controller-toyota-4runner-n210"],
  "Toyota|4Runner N280": ["roar-4x4-throttle-controller-toyota-4runner-n280"],
  "Toyota|4Runner N280 (2009 onwards)": ["roar-4x4-throttle-controller-toyota-4runner-n280"],
  "Toyota|Corolla (2007–2012)": ["throttle-controller-toyota-corolla-2007-2012"],
  "Toyota|Corolla Hatch (2012–2018)": ["throttle-controller-toyota-corolla-hatch-2012-2018"],
  "Toyota|Corolla Sedan (2014–2019)": ["throttle-controller-toyota-corolla-sedan-2014-2019"],
  "Toyota|FJ Cruiser": ["fj-cruiser-throttle-controller-suits-2011-2016-plug-and-play"],
  "Toyota|Fj cruiser (2006 onwards)": ["roar-4x4-throttle-controller-toyota-fj-cruiser"],
  "Toyota|Fortuner AN150": ["roar-4x4-throttle-controller-toyota-fortuner-an150-an160"],
  "Toyota|Fortuner AN150/AN160 (2015–2020)": ["roar-4x4-throttle-controller-toyota-fortuner-an150-an160"],
  "Toyota|Fortuner AN150/AN160 (2020 onwards)": ["roar-4x4-throttle-controller-toyota-fortuner-an150-an160"],
  "Toyota|Granvia": ["roar-4x4-throttle-controller-toyota-granvia"],
  "Toyota|HARRIER (2013 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|HiAce": ["roar-4x4-throttle-controller-toyota-hiace-h200", "roar-4x4-throttle-controller-toyota-hiace-h300"],
  "Toyota|HiAce H200": ["roar-4x4-throttle-controller-toyota-hiace-h200"],
  "Toyota|Hiace H200 (2004–2019)": ["roar-4x4-throttle-controller-toyota-hiace-h200"],
  "Toyota|HiAce H300": ["roar-4x4-throttle-controller-toyota-hiace-h300"],
  "Toyota|Hiace H300 (2019 onwards)": ["roar-4x4-throttle-controller-toyota-hiace-h300"],
  "Toyota|Highlander": ["roar-4x4-throttle-controller-toyota-highlander"],
  "Toyota|HIGHLANDER (2007 onwards)": ["roar-4x4-throttle-controller-toyota-highlander"],
  "Toyota|Hilux N70": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Hilux N70 (2005–2011)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Hilux N70 (2011–2015)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Hilux N70-pre / 5-pin (2000–2004)": ["roar-4x4-throttle-controller-toyota-hilux-2000-2004-t63"],
  "Toyota|Hilux N80": ["roar-4x4-throttle-controller-toyota-hilux-n80-2015-2018", "roar-4x4-throttle-controller-toyota-hilux-n80-2018-2020", "roar-4x4-throttle-controller-toyota-hilux-n80-2020-onwards"],
  "Toyota|Hilux N80 (2015–2018)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2015-2018"],
  "Toyota|Hilux N80 (2018–2020)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2018-2020"],
  "Toyota|Hilux N80 (2020–2024)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2020-onwards"],
  "Toyota|Hilux N80 (2024 onwards)": ["roar-4x4-throttle-controller-toyota-hilux-n80-2020-onwards"],
  "Toyota|Land cruiser 100 SERIES V8 (2000 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-100-v8-831"],
  "Toyota|Land cruiser 100 SERIES with 5-pin pedal plug (2000 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-100-5pin-t63"],
  "Toyota|Land cruiser LC200 (2007–2012)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Land cruiser LC200 (2012–2015)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Land cruiser LC200 (2015–2021)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Land cruiser LC300 (2021 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-300"],
  "Toyota|LandCruiser 100": ["roar-4x4-throttle-controller-toyota-landcruiser-100-v8-831", "roar-4x4-throttle-controller-toyota-landcruiser-100-5pin-t63"],
  "Toyota|LandCruiser 200": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|LandCruiser 300": ["roar-4x4-throttle-controller-toyota-landcruiser-300"],
  "Toyota|Prado 120": ["roar-4x4-throttle-controller-toyota-prado-j120"],
  "Toyota|Prado 150": ["throttle-controller-toyota-prado-j150-2009-2013", "throttle-controller-toyota-prado-j150-2013-2017", "throttle-controller-toyota-prado-j150-2017-2021", "throttle-controller-toyota-prado-j150-2021-2023"],
  "Toyota|Prado J120": ["roar-4x4-throttle-controller-toyota-prado-j120"],
  "Toyota|Prado J120 (2002–2006)": ["roar-4x4-throttle-controller-toyota-prado-j120"],
  "Toyota|Prado J120 (2006–2009)": ["roar-4x4-throttle-controller-toyota-prado-j120"],
  "Toyota|Prado J150": ["throttle-controller-toyota-prado-j150-2009-2013", "throttle-controller-toyota-prado-j150-2013-2017", "throttle-controller-toyota-prado-j150-2017-2021", "throttle-controller-toyota-prado-j150-2021-2023"],
  "Toyota|Prado J150 (2009–2013)": ["throttle-controller-toyota-prado-j150-2009-2013"],
  "Toyota|Prado J150 (2013–2015)": ["throttle-controller-toyota-prado-j150-2013-2017"],
  "Toyota|Prado J150 (2015–2017)": ["throttle-controller-toyota-prado-j150-2013-2017"],
  "Toyota|Prado J150 (2017–2021)": ["throttle-controller-toyota-prado-j150-2017-2021"],
  "Toyota|Prado J150 (2021–2023)": ["throttle-controller-toyota-prado-j150-2021-2023"],
  "Toyota|RAV4": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA30 (2006–2008)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA30 (2008–2012)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA40 (2013–2015)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA40 (2015–2018)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rav4 XA50 (2019 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Sequoia": ["roar-4x4-throttle-controller-toyota-sequoia"],
  "Toyota|Sequqia (2007 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Volkswagen|Amarok": ["roar-4x4-throttle-controller-volkswagen-amarok", "roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Volkswagen|Amarok 1st gen early (2011–2016)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Amarok 1st gen facelift (2016–2022)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Amarok 2H": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|T5 (2009–2015)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Volkswagen|T5 Multivan (2009–2015)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Volkswagen|T6 (2015 onwards)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Volkswagen|Touareg": ["roar-4x4-throttle-controller-volkswagen-touareg"],
  "Volkswagen|Touareg (2002–2018)": ["roar-4x4-throttle-controller-volkswagen-touareg"],
  "Volkswagen|Transporter (2009 onwards)": ["roar-4x4-throttle-controller-volkswagen-transporter"],
  "Audi|A1 (2010–2013)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A3 (1999–2004)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A4 (2001–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A6 (2004–2011)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|A8 (2002–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|Rs6 (2008–2010)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|S4 (2001–2009)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|S8 D3 (2002–2010)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Audi|Tt Mk1 (1998–2006)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Bentley|Brooklands (2008 onwards)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Bentley|Continental (2003–2004)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Bentley|Continental gt (2004–2011)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Ford|Falcon FG (2008–2014)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Ford|Falcon FG X (2014–2016)": ["roar-4x4-throttle-controller-ldv-g10"],
  "Ford|Territory SZ (2011–2016)": ["roar-4x4-throttle-controller-ldv-g10"],
  "GWM|Tank 500 (2022 onwards)": ["throttle-controller-suits-gwm-tank-300-2022-current"],
  "Haval|H2 (2014 onwards)": ["roar-4x4-throttle-controller-haval-h6"],
  "Haval|Jolion (2020 onwards)": ["roar-4x4-throttle-controller-haval-h6"],
  "Skoda|Fabia (1999–2014)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Skoda|Octavia (2000–2010)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Beetle (1998–2011)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Bora (1999–2005)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Golf (1997–2003)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Jetta A5 (2006–2011)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Multivan (2023 onwards)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Passat B5/B5.5Typ 3B/3Bg (1997–2006)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Phaeton (2002–2006)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Volkswagen|Polo Typ 6Q/9N/9N34Th Gen (2002–2009)": ["roar-4x4-throttle-controller-volkswagen-amarok"],
  "Alfa Romeo|159 (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Brera coupe (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Giulia (2016 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Giulietta (2010 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|Mito (2008–2018)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|SPIDER (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Alfa Romeo|STELVIO (2017 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|500 (2007–2019)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|500X (2015 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|595 (2020 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|Abarth 500 (2007–2014)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|BRAVO (2011 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|DOBLO 3V 263 (2009 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|Ducato (2006 onwards)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Fiat|Punto (2011–2018)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Holden|Astra Ah/Pj (1998–2016)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Commodore Ve (2006–2013)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Cruze JG (2009–2011)": ["throttle-controller-holden-cruze-jg-2009-2011"],
  "Holden|Cruze JH (2011–2016)": ["throttle-controller-holden-cruze-jh-2011-2016"],
  "Holden|MALIBU (2008–2016)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Statesman Wm (2006–2013)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Tigra (2002–2009)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|Vectra C (2002–2008)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Holden|ZAFIRA (2000 onwards)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Nissan|Navara D23/NP300 (2015–2020)": ["throttle-controller-nissan-navara-d23-2015-2020"],
  "Nissan|Navara D23 MY21 (2021 onwards)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Nissan|Pathfinder (2005–2012)": ["roar-4x4-throttle-controller-nissan-navara-d40"],
  "Opel/Vauxhall|Astra H/J/G (2000–2015)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Opel/Vauxhall|Corsa (2000 onwards)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Opel/Vauxhall|Insignia (2008 onwards)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Saab|All Models (2005–2011)": ["roar-4x4-throttle-controller-holden-colorado-rg"],
  "Smart|FORFOUR (up to 2007)": ["roar-4x4-throttle-controller-jeep-renegade"],
  "Lexus|GS S190 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS 30/35/43/460 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS300 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS350 GRS191 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS430 (2005–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS450H (2007–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|GS460 (2008–2011)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|Rx330 (2004–2006)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|Rx350 (2004–2009)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Lexus|Rx400H (2005–2009)": ["roar-4x4-throttle-controller-lexus-gx470"],
  "Suzuki|Swift Sport (2005–2011)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Kluger (2000–2007)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Land cruiser 70 Series (VDJ76/78/79) (2007–2009)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Toyota|Prius (2004–2009)": ["roar-4x4-throttle-controller-toyota-hilux-n70"],
  "Mitsubishi|Mirage (2017 onwards)": ["roar-4x4-throttle-controller-mitsubishi-triton-2016-2018"],
  "Suzuki|LIANA (2005 onwards)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Swift (2004–2017)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Suzuki|Swift Sport (2012–2018)": ["roar-4x4-throttle-controller-suzuki-vitara"],
  "Mitsubishi|COLT (2002–2013)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Mitsubishi|Challenger (2008–2016)": ["roar-4x4-throttle-controller-mitsubishi-triton-ml-mn"],
  "Mitsubishi|Mirage (2012–2016)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Suzuki|KIZASHI (2013)": ["roar-4x4-throttle-controller-mitsubishi-montero"],
  "Chevrolet|Silverado 2500HD (2020 onwards)": ["roar-4x4-throttle-controller-chevrolet-silverado-2019-2022"],
  "Ford|Focus LW (2011–2015)": ["throttle-controller-ford-focus-lw-2011-2015"],
  "Ford|Focus LZ (2015–2018)": ["throttle-controller-ford-focus-lz-2015-2018"],
  "Ford|Focus SA (2018–2022)": ["throttle-controller-ford-focus-sa-2018-2022"],
  "Ford|Mondeo (2014 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|Mustang (2011 onwards)": ["roar-4x4-throttle-controller-ford-f150"],
  "Ford|PUMA (2019 onwards)": ["throttle-controller-ford-puma-2020-onwards"],
  "Ford|Puma (2020 onwards)": ["throttle-controller-ford-puma-2020-onwards"],

  "Mazda|5 (2011 onwards)": ["roar-4x4-throttle-controller-mazda-bt-50-up-ur"],
  "Mazda|6 GH (2008–2012)": ["roar-4x4-throttle-controller-mazda-bt-50-up-ur"],
  "Volkswagen|Amarok (2023 onwards)": ["roar-4x4-throttle-controller-ford-ranger-nextgen-t6"],
  "Mitsubishi|Outlander 4th gen (2022 onwards)": ["throttle-controller-mitsubishi-outlander-2022-onwards"],
  "Nissan|Almera (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Altima (2006 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|GT-R (2007 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Leaf (2011 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Maxima (2004–2014)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Micra (2001 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Pulsar (2000 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Tiida C11/C12/C13 (2004 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Townstar (2022 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|Townstar E-Tech (2024 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Nissan|X-Trail T31 (2007–2013)": ["roar-4x4-throttle-controller-nissan-x-trail-t32"],
  "Renault|Arkana (2020 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|CLio III / iv / v (2005 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Captur (2013 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Kangoo (2020 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Kangoo E-Tech (2022 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|LATITUDE (2010 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Laguna III (2007–2015)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Megane (2002 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Renault|Scenic (2003 onwards)": ["roar-4x4-throttle-controller-nissan-juke"],
  "Lexus|CT200H (2011–2021)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es250 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es300H (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Es350 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS L10 (2011 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS F (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS250 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS350 Grl10 (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|GS450H (2012 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|IS F (2007–2014)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|IS200T (2015–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is220D (2006–2010)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is250 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is300 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is300H (2013 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is350 (2005 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Is500F (2021 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LC 500 (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LC 500H (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS460 (2006 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS500 (2017 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS500H (2017 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|LS600H (2007–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Lx600 (2021 onwards)": ["roar-4x4-throttle-controller-lexus-lx570"],
  "Lexus|RC F (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|RC200T (2016–2017)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|RZ 300E (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|RZ 450E (2023 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rc300 (2018 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rc300H (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|Rc350 (2015 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|UX 200 (2019 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|UX 250H (2020 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Lexus|UX 300H (2024 onwards)": ["roar-4x4-throttle-controller-lexus-gx550h"],
  "Toyota|Aurion (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|CH-R AX10 early (2016–2019)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|CH-R AX10 facelift (2019 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Camry XV40 (2006–2009)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Camry XV40 (2009–2011)": ["throttle-controller-toyota-camry-xv40-2009-2011"],
  "Toyota|Camry XV50 (2011–2015)": ["throttle-controller-toyota-camry-xv50-2011-2015"],
  "Toyota|Camry XV50 (2015–2017)": ["throttle-controller-toyota-camry-xv50-2015-2017"],
  "Toyota|Camry XV70 (2017–2021)": ["throttle-controller-toyota-camry-xv70-2017-2021"],
  "Toyota|Camry XV70 (2021 onwards)": ["throttle-controller-toyota-camry-xv70-2021-2024"],
  "Toyota|Kluger XU40 (2007–2010)": ["roar-4x4-throttle-controller-toyota-highlander"],
  "Toyota|Kluger XU40 (2010–2013)": ["throttle-controller-toyota-kluger-xu40-2010-2014"],
  "Toyota|Kluger XU50 (2014–2017)": ["throttle-controller-toyota-kluger-xu50-2014-2017"],
  "Toyota|Kluger XU50 (2017–2020)": ["throttle-controller-toyota-kluger-xu50-2017-2020"],
  "Toyota|Kluger XU70 (2021 onwards)": ["throttle-controller-toyota-kluger-xu70-2021-onwards"],
  "Toyota|Land cruiser 70 Series (VDJ76/78/79) (2009 onwards)": ["roar-4x4-throttle-controller-toyota-landcruiser-200"],
  "Toyota|Prado 250 (2024 onwards)": ["roar-4x4-throttle-controller-toyota-prado-250"],
  "Toyota|Prius (2010 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Rukus (2007–2015)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Tarago (2006 onwards)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Tundra (2007 onwards)": ["roar-4x4-throttle-controller-toyota-sequoia"],
  "Toyota|Yaris XP90 (2005–2008)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Yaris XP90 (2008–2011)": ["roar-4x4-throttle-controller-toyota-rav4"],
  "Toyota|Yaris XP130 (2011–2014)": ["throttle-controller-toyota-yaris-xp130-2011-2014"],
  "Toyota|Yaris XP130 Series II (2014–2017)": ["throttle-controller-toyota-yaris-xp130-series-ii-2014-2017"],
  "Toyota|Yaris XP130 Series III (2017–2020)": ["throttle-controller-toyota-yaris-xp130-series-iii-2017-2020"],
  "Toyota|Yaris XP210 (2020 onwards)": ["throttle-controller-toyota-yaris-xp210-2020-onwards"],
  "Toyota|C-HR AX10 (2019–2024)": ["throttle-controller-toyota-c-hr-ax10-2019-2024"],

  "Lexus|Es300 (2002–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Lexus|Ls430 (2001–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Lexus|Sc430 (2001–2010)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Camry Xv30 (2001–2006)": ["roar-4x4-throttle-controller-plug-831"],
  "Toyota|Prado 250": ["roar-4x4-throttle-controller-toyota-prado-250"]
};
var VF_DRIVE_CLASS = {
  "Alfa Romeo|159 (2006 onwards)": "passenger",
  "Alfa Romeo|Brera coupe (2006 onwards)": "passenger",
  "Alfa Romeo|Giulia (2016 onwards)": "passenger",
  "Alfa Romeo|Giulietta (2010 onwards)": "passenger",
  "Alfa Romeo|Mito (2008–2018)": "passenger",
  "Alfa Romeo|SPIDER (2006 onwards)": "passenger",
  "Alfa Romeo|STELVIO (2017 onwards)": "4wd",
  "Audi|A1 (2010–2013)": "passenger",
  "Audi|A2 (2000–2005)": "passenger",
  "Audi|A3 (1999–2004)": "passenger",
  "Audi|A4 (2001–2009)": "passenger",
  "Audi|A6 (2004–2011)": "passenger",
  "Audi|A8 (2002–2009)": "passenger",
  "Audi|Q7 (2007–2015)": "4wd",
  "Audi|Rs6 (2008–2010)": "passenger",
  "Audi|S4 (2001–2009)": "passenger",
  "Audi|S8 D3 (2002–2010)": "passenger",
  "Audi|Tt Mk1 (1998–2006)": "passenger",
  "Bentley|Brooklands (2008 onwards)": "passenger",
  "Bentley|Continental (2003–2004)": "passenger",
  "Bentley|Continental gt (2004–2011)": "passenger",
  "Buick|Excelle (2003–2016)": "passenger",
  "Buick|Gl8 (2000–2010)": "passenger",
  "Buick|Hideo (all years)": "passenger",
  "Buick|REGAL (2011 onwards)": "passenger",
  "Buick|VERANO (2012–2014)": "passenger",
  "Cadillac|BLS (2005–2010)": "passenger",
  "Cadillac|Srx (all years)": "passenger",
  "Cadillac|Sts (2005–2011)": "passenger",
  "Cadillac|Xts (2013–2019)": "passenger",
  "Chevrolet|Colorado RG-twin (2012–2016)": "4wd",
  "Chevrolet|Colorado RG-twin facelift (2017–2022)": "4wd",
  "Chevrolet|Cruze JG (2009–2011)": "passenger",
  "Chevrolet|Cruze JH (2011–2016)": "passenger",
  "Chevrolet|Hhr (2006–2011)": "passenger",
  "Chevrolet|Malibu (2008–2018)": "passenger",
  "Chevrolet|Orlando (2011–2018)": "passenger",
  "Chevrolet|Sail (2001–2014)": "passenger",
  "Chevrolet|Silverado": "4wd",
  "Chevrolet|Silverado 1500": "4wd",
  "Chevrolet|Silverado 2500HD (2020 onwards)": "4wd",
  "Chevrolet|Silverado 2500HD/3500HD": "4wd",
  "Chevrolet|Silverado 3500HD (2020 onwards)": "4wd",
  "Chevrolet|Suburban": "4wd",
  "Chevrolet|Tahoe": "4wd",
  "Chevrolet|Tornado (2011 onwards)": "passenger",
  "Chevrolet|Trailblazer (2012 onwards)": "4wd",
  "Chrysler|200 (2015–2017)": "passenger",
  "Citroen|Jumper (2015 onwards)": "passenger",
  "Dacia|Duster (2009 onwards)": "4wd",
  "Dacia|Logan (2004 onwards)": "passenger",
  "Dacia|Sandero (2007 onwards)": "passenger",
  "Daihatsu|AYLA (2017 onwards)": "passenger",
  "Daihatsu|HIJET TRUCK (2014 onwards)": "passenger",
  "Daihatsu|ROCKY (2021 onwards)": "passenger",
  "Daihatsu|SIGRA (2016 onwards)": "passenger",
  "Daihatsu|TERRIOS (2006 onwards)": "passenger",
  "Daihatsu|XENIA (2015 onwards)": "passenger",
  "Datsun|GO (2014 onwards)": "passenger",
  "Dodge|DART (2013 onwards)": "passenger",
  "Dodge|RAM": "4wd",
  "Dodge|RAM 1500": "4wd",
  "Dodge|RAM 1500 (2019 onwards)": "4wd",
  "Dodge|RAM 1500 TRX": "4wd",
  "Dodge|RAM 1500 TRX (2021 onwards)": "4wd",
  "Dodge|RAM 2500": "4wd",
  "Dodge|RAM ProMaster 1500 (2014 onwards)": "4wd",
  "Dodge|RAM ProMaster 2500 (2014 onwards)": "4wd",
  "Dodge|RAM ProMaster 3500 (2014 onwards)": "4wd",
  "Dodge|RAM ProMaster City (2015 onwards)": "passenger",
  "Fiat|500 (2007–2019)": "passenger",
  "Fiat|500L (2012 onwards)": "passenger",
  "Fiat|500X (2015 onwards)": "passenger",
  "Fiat|595 (2020 onwards)": "passenger",
  "Fiat|Abarth 500 (2007–2014)": "passenger",
  "Fiat|BRAVO (2011 onwards)": "passenger",
  "Fiat|DOBLO 3V 263 (2009 onwards)": "passenger",
  "Fiat|Ducato (2006 onwards)": "mixed",
  "Fiat|Idea (2003–2016)": "passenger",
  "Fiat|PANDA (2012 onwards)": "passenger",
  "Fiat|Punto (2011–2018)": "passenger",
  "Ford|Bronco": "4wd",
  "Ford|Bronco (2020 onwards)": "4wd",
  "Ford|Bronco Sport (2020 onwards)": "4wd",
  "Ford|C-Max (2011 onwards)": "passenger",
  "Ford|Edge (2015 onwards)": "4wd",
  "Ford|Endura (2018–2019)": "4wd",
  "Ford|Escape (2013 onwards)": "4wd",
  "Ford|Escort (2015 onwards)": "passenger",
  "Ford|Everest": "4wd",
  "Ford|Everest 3rd Gen": "4wd",
  "Ford|Everest Next Gen": "4wd",
  "Ford|Everest Next-Gen (2022 onwards)": "4wd",
  "Ford|Everest Raptor": "4wd",
  "Ford|Everest Raptor Next-Gen (2022 onwards)": "4wd",
  "Ford|Everest UA": "4wd",
  "Ford|Everest UA (2016–2018)": "4wd",
  "Ford|Everest UA II (2018–2022)": "4wd",
  "Ford|Explorer": "4wd",
  "Ford|Explorer (2011 onwards)": "4wd",
  "Ford|F-150 Raptor": "4wd",
  "Ford|F-150 RAPTOR (2017 onwards)": "4wd",
  "Ford|F-150 SVT RAPTOR (2010–2014)": "4wd",
  "Ford|F150": "4wd",
  "Ford|F150 (2009 onwards)": "4wd",
  "Ford|F250": "4wd",
  "Ford|F250 (2010 onwards)": "4wd",
  "Ford|F350": "4wd",
  "Ford|F350 (2010 onwards)": "4wd",
  "Ford|Falcon": "passenger",
  "Ford|Falcon FG (2008–2014)": "passenger",
  "Ford|Falcon FG X (2014–2016)": "passenger",
  "Ford|Focus LW (2011–2015)": "passenger",
  "Ford|Focus LZ (2015–2018)": "passenger",
  "Ford|Focus SA (2018–2022)": "passenger",
  "Ford|Ftruck (2009 onwards)": "passenger",
  "Ford|FUSION (2011 onwards)": "passenger",
  "Ford|GRAND C-MAX (2010 onwards)": "passenger",
  "Ford|Kuga (2012 onwards)": "4wd",
  "Ford|Maverick": "4wd",
  "Ford|Maverick (2022 onwards)": "4wd",
  "Ford|Mondeo (2014 onwards)": "passenger",
  "Ford|Mustang (2011 onwards)": "passenger",
  "Ford|PUMA (2019 onwards)": "passenger",
  "Ford|Puma (2020 onwards)": "passenger",

  "Ford|Ranger & Raptor": "4wd",
  "Ford|Ranger Next Gen": "4wd",
  "Ford|Ranger Next-Gen (2022 onwards)": "4wd",
  "Ford|Ranger NextGen T6": "4wd",
  "Ford|Ranger PK": "4wd",
  "Ford|Ranger PX1": "4wd",
  "Ford|Ranger PX1 (2012–2015)": "4wd",
  "Ford|Ranger PX2": "4wd",
  "Ford|Ranger PX2 (2016–2018)": "4wd",
  "Ford|Ranger PX2 PX3": "4wd",
  "Ford|Ranger PX3": "4wd",
  "Ford|Ranger PX3 (2019–2021)": "4wd",
  "Ford|Ranger PX3/PX4": "4wd",
  "Ford|Ranger Raptor": "4wd",
  "Ford|Ranger raptor Next-Gen Raptor (2022 onwards)": "4wd",
  "Ford|Ranger raptor PX3 Raptor (2018–2021)": "4wd",
  "Ford|Raptor": "4wd",
  "Ford|raptor (F150) (2011–2017)": "4wd",
  "Ford|S-Max (2015 onwards)": "passenger",
  "Ford|Territory": "passenger",
  "Ford|Territory SZ (2011–2016)": "passenger",
  "Ford|Transit (2013 onwards)": "mixed",
  "GMC|Canyon": "4wd",
  "Gmc|Canyon (2014–2022)": "4wd",
  "GMC|Sierra": "4wd",
  "GMC|Yukon": "4wd",
  "Great Wall|C20 (2012–2014)": "passenger",
  "Great Wall|C30 (2010–2016)": "passenger",
  "Great Wall|C50 (2012–2016)": "passenger",
  "Great Wall|CANNON Cannon gen1 (2020–2023)": "4wd",
  "Great Wall|CANNON Cannon refresh (2024 onwards)": "4wd",
  "Great Wall|COOLBEAR (2010–2015)": "passenger",
  "Great Wall|FLORID (2009–2013)": "passenger",
  "Great Wall|H2 (2014 onwards)": "passenger",
  "Great Wall|H6 (2011 onwards)": "passenger",
  "Great Wall|H8 (2013–2018)": "4wd",
  "Great Wall|H9 (2014 onwards)": "4wd",
  "Great Wall|LINGAO (all years)": "passenger",
  "Great Wall|M2 (2012 onwards)": "passenger",
  "Great Wall|M4 (2012 onwards)": "passenger",
  "Great Wall|V80 (2007–2015)": "mixed",
  "Greatwall|Cannon": "4wd",
  "GWM|C20 (2012–2014)": "passenger",
  "GWM|C30 (2010–2016)": "passenger",
  "GWM|C50 (2012–2016)": "passenger",
  "GWM|Cannon": "4wd",
  "GWM|Cannon Alpha": "4wd",
  "GWM|CANNON Cannon gen1 (2020–2023)": "4wd",
  "GWM|CANNON Cannon refresh (2024 onwards)": "4wd",
  "GWM|Cannon NPW": "4wd",
  "GWM|COOLBEAR (2010–2015)": "passenger",
  "GWM|FLORID (2009–2013)": "passenger",
  "GWM|H2 (all years)": "passenger",
  "GWM|H6 (2011 onwards)": "passenger",
  "GWM|H8 (2013 onwards)": "4wd",
  "GWM|H9 (2014 onwards)": "4wd",
  "GWM|LINGAO (all years)": "passenger",
  "GWM|M2 (2012 onwards)": "passenger",
  "GWM|M4 (2012 onwards)": "passenger",
  "GWM|Tank 300": "4wd",
  "GWM|Tank 300 (2021 onwards)": "4wd",
  "GWM|Tank 500": "4wd",
  "GWM|Tank 500 (2022 onwards)": "4wd",
  "GWM|Ute": "4wd",
  "GWM|V80 (2007–2015)": "mixed",
  "Haval|C20 (2012–2014)": "passenger",
  "Haval|C30 (2010–2016)": "passenger",
  "Haval|C50 (2012–2016)": "passenger",
  "Haval|Cannon": "4wd",
  "Haval|CANNON Cannon gen1 (2020–2023)": "4wd",
  "Haval|CANNON Cannon refresh (2024 onwards)": "4wd",
  "Haval|COOLBEAR (2010–2015)": "passenger",
  "Haval|FLORID (2009–2013)": "passenger",
  "Haval|H2": "passenger",
  "Haval|H2 (2014 onwards)": "passenger",
  "Haval|H6": "passenger",
  "Haval|H6 (2011 onwards)": "passenger",
  "Haval|H8 (2013 onwards)": "4wd",
  "Haval|H9": "4wd",
  "Haval|H9 (2014 onwards)": "4wd",
  "Haval|Jolion (2020 onwards)": "passenger",
  "Haval|LINGAO (all years)": "passenger",
  "Haval|M2 (2012 onwards)": "passenger",
  "Haval|M4 (2012 onwards)": "passenger",
  "Haval|V80 (2007–2015)": "mixed",
  "Hino|300 Series": "passenger",
  "Hino|300 SERIES (2011 onwards)": "passenger",
  "Holden|Astra Ah/Pj (1998–2016)": "passenger",
  "Holden|Colorado": "4wd",
  "Holden|Colorado RC": "4wd",
  "Holden|Colorado RG (2012–2016)": "4wd",
  "Holden|Colorado RG Series II (2017–2020)": "4wd",
  "Holden|Commodore Ve (2006–2013)": "passenger",
  "Holden|Cruze JG (2009–2011)": "passenger",
  "Holden|Cruze JH (2011–2016)": "passenger",
  "Holden|MALIBU (2008–2016)": "passenger",
  "Holden|RG Colorado": "4wd",
  "Holden|Statesman Wm (2006–2013)": "passenger",
  "Holden|Tigra (2002–2009)": "passenger",
  "Holden|Trailblazer": "4wd",
  "Holden|Trailblazer (2012 onwards)": "4wd",
  "Holden|Trax": "4wd",
  "Holden|Vectra C (2002–2008)": "passenger",
  "Holden|ZAFIRA (2000 onwards)": "passenger",
  "Hummer|H3": "4wd",
  "Hummer|H3 (2006–2010)": "passenger",
  "Hyundai|iLoad": "4wd",
  "Hyundai|iLoad / iMax": "4wd",
  "Hyundai|iMax": "4wd",
  "Hyundai|Santa Fe": "4wd",
  "Ineos|Grenadier": "4wd",
  "Isuzu|D-Max": "4wd",
  "Isuzu|D-Max 3rd gen (2021–2024)": "4wd",
  "Isuzu|D-Max 3rd gen facelift (2024 onwards)": "4wd",
  "Isuzu|D-Max RC": "4wd",
  "Isuzu|D-Max RG": "4wd",
  "Isuzu|D-Max RT early (2012–2016)": "4wd",
  "Isuzu|D-Max RT facelift (2017–2020)": "4wd",
  "Isuzu|D-Max TF": "4wd",
  "Isuzu|MU-X": "4wd",
  "Isuzu|MU-X RF": "4wd",
  "Isuzu|MU-X RJ": "4wd",
  "Isuzu|MUX": "4wd",
  "Isuzu|Mux 2nd gen (2021–2025)": "4wd",
  "Isuzu|Mux 2nd gen facelift (2025 onwards)": "4wd",
  "Isuzu|Mux RF early (2013–2016)": "4wd",
  "Isuzu|Mux RF Series II (2017–2020)": "4wd",
  "Jaguar|Xe (2015 onwards)": "passenger",
  "Jaguar|XF X260 (2015 onwards)": "passenger",
  "Jeep|Cherokee": "4wd",
  "Jeep|Cherokee (2014 onwards)": "4wd",
  "Jeep|Cherokee KL": "4wd",
  "Jeep|Compass": "4wd",
  "Jeep|Compass (2017 onwards)": "4wd",
  "Jeep|Gladiator": "4wd",
  "Jeep|Gladiator JT": "4wd",
  "Jeep|GLADIATOR JT (2020–2024)": "4wd",
  "Jeep|GLADIATOR JT (2025 onwards)": "4wd",
  "Jeep|Grand Cherokee": "4wd",
  "Jeep|Grand cherokee (2022 onwards)": "4wd",
  "Jeep|Grand Cherokee WK": "4wd",
  "Jeep|Grand Cherokee WK2": "4wd",
  "Jeep|Grand Cherokee WL": "4wd",
  "Jeep|Renegade": "4wd",
  "Jeep|RENEGADE (2014 onwards)": "4wd",
  "Jeep|Wrangler JK": "4wd",
  "Jeep|Wrangler JL": "4wd",
  "Jeep|Wrangler JL (2018–2023)": "4wd",
  "Jeep|Wrangler JL (2024 onwards)": "4wd",
  "Jeep|Wrangler JT GLADIATOR (2020–2024)": "4wd",
  "Jeep|Wrangler JT GLADIATOR (2025 onwards)": "4wd",
  "Kia|Sorento": "4wd",
  "Kia|Sportage": "4wd",
  "Land Rover|Defender": "4wd",
  "Land Rover|Defender (2019 onwards)": "4wd",
  "Land Rover|Defender 110": "4wd",
  "Land Rover|Defender 130": "4wd",
  "Land Rover|Discovery 5": "4wd",
  "Land Rover|Discovery 5 (2017 onwards)": "4wd",
  "Land Rover|Discovery Sport": "4wd",
  "Land Rover|Discovery sport (2014 onwards)": "4wd",
  "Land Rover|Evoque": "passenger",
  "Land Rover|Evoque (2016 onwards)": "passenger",
  "Land Rover|Range Rover": "4wd",
  "Land Rover|Range Rover 4Th Gen (2012 onwards)": "4wd",
  "Land Rover|Range Rover Sport": "4wd",
  "Land Rover|Range rover sport (2015 onwards)": "4wd",
  "Land Rover|Range Rover Velar": "4wd",
  "Land Rover|RANGE ROVER VELAR (2017 onwards)": "4wd",
  "LDV|D90": "4wd",
  "LDV|G10 (2014 onwards)": "mixed",
  "LDV|MIFA (2022 onwards)": "mixed",
  "LDV|T60": "4wd",
  "LDV|V80 (2014 onwards)": "mixed",
  "Lexus|450D (2018 onwards)": "passenger",
  "Lexus|CT200H (2011–2021)": "passenger",
  "Lexus|Es200 (2015 onwards)": "passenger",
  "Lexus|Es200H (2018 onwards)": "passenger",
  "Lexus|Es240 (2006 onwards)": "passenger",
  "Lexus|Es250 (2012 onwards)": "passenger",
  "Lexus|Es300 (2002–2006)": "passenger",
  "Lexus|Es300H (2012 onwards)": "passenger",
  "Lexus|Es350 (2006 onwards)": "passenger",
  "Lexus|GS 30/35/43/460 (2005–2011)": "passenger",
  "Lexus|GS F (2015 onwards)": "passenger",
  "Lexus|GS L10 (2011 onwards)": "passenger",
  "Lexus|GS S190 (2005–2011)": "passenger",
  "Lexus|GS250 (2012 onwards)": "passenger",
  "Lexus|GS300 (2005–2011)": "passenger",
  "Lexus|GS350 Grl10 (2012 onwards)": "passenger",
  "Lexus|GS350 GRS191 (2005–2011)": "passenger",
  "Lexus|GS430 (2005–2011)": "passenger",
  "Lexus|GS430 (2012 onwards)": "passenger",
  "Lexus|GS450H (2007–2011)": "passenger",
  "Lexus|GS450H (2012 onwards)": "passenger",
  "Lexus|GS460 (2008–2011)": "passenger",
  "Lexus|GX 460": "4wd",
  "Lexus|GX 470": "4wd",
  "Lexus|GX 550": "4wd",
  "Lexus|GX400 (2012 onwards)": "4wd",
  "Lexus|GX460": "4wd",
  "Lexus|GX460 (2010 onwards)": "4wd",
  "Lexus|GX470 (2003–2009)": "4wd",
  "Lexus|GX550 (2024 onwards)": "4wd",
  "Lexus|GX550H (2024 onwards)": "4wd",
  "Lexus|IS F (2007–2014)": "passenger",
  "Lexus|IS200D (2010–2012)": "passenger",
  "Lexus|IS200T (2015–2017)": "passenger",
  "Lexus|Is220 (2005 onwards)": "passenger",
  "Lexus|Is220D (2006–2010)": "passenger",
  "Lexus|Is250 (2006 onwards)": "passenger",
  "Lexus|Is300 (2006 onwards)": "passenger",
  "Lexus|Is300H (2013 onwards)": "passenger",
  "Lexus|Is350 (2005 onwards)": "passenger",
  "Lexus|Is500F (2021 onwards)": "passenger",
  "Lexus|LC 500 (2018 onwards)": "passenger",
  "Lexus|LC 500H (2019 onwards)": "passenger",
  "Lexus|Lm (2019 onwards)": "4wd",
  "Lexus|LM 350 (2019 onwards)": "4wd",
  "Lexus|LM 350H (2019 onwards)": "4wd",
  "Lexus|LM 500H (2023 onwards)": "4wd",
  "Lexus|LS F (2008–2013)": "passenger",
  "Lexus|Ls430 (2001–2006)": "passenger",
  "Lexus|LS460 (2006 onwards)": "passenger",
  "Lexus|LS500 (2017 onwards)": "passenger",
  "Lexus|LS500H (2017 onwards)": "passenger",
  "Lexus|LS600H (2007–2017)": "passenger",
  "Lexus|LX 570": "4wd",
  "Lexus|LX 600": "4wd",
  "Lexus|Lx500D (2022 onwards)": "4wd",
  "Lexus|Lx570 (2008 onwards)": "4wd",
  "Lexus|Lx600 (2021 onwards)": "4wd",
  "Lexus|NX200 (2021 onwards)": "4wd",
  "Lexus|NX200T (2015–2021)": "4wd",
  "Lexus|NX300H (2014–2021)": "4wd",
  "Lexus|NX350 (2021 onwards)": "4wd",
  "Lexus|NX350H (2021 onwards)": "4wd",
  "Lexus|NX450+ (2021 onwards)": "4wd",
  "Lexus|NX AZ20 (2022 onwards)": "4wd",

  "Lexus|NX AZ10 (2017–2022)": "4wd",

  "Lexus|RC F (2015 onwards)": "passenger",
  "Lexus|RC200T (2016–2017)": "passenger",
  "Lexus|Rc300 (2018 onwards)": "passenger",
  "Lexus|Rc300H (2015 onwards)": "passenger",
  "Lexus|Rc350 (2015 onwards)": "passenger",
  "Lexus|Rx Al10 (2008–2015)": "4wd",
  "Lexus|Rx Al20 (2015 onwards)": "4wd",
  "Lexus|Rx200T (2015–2017)": "4wd",
  "Lexus|Rx270 (2010 onwards)": "4wd",
  "Lexus|Rx300 (2018 onwards)": "4wd",
  "Lexus|Rx330 (2004–2006)": "4wd",
  "Lexus|Rx350 (2004–2009)": "4wd",
  "Lexus|Rx350 (2010 onwards)": "4wd",
  "Lexus|Rx350H (2023 onwards)": "4wd",
  "Lexus|Rx400H (2005–2009)": "4wd",
  "Lexus|Rx450H (2010 onwards)": "4wd",
  "Lexus|Rx450H+ (2023 onwards)": "4wd",
  "Lexus|RZ 300E (2023 onwards)": "passenger",
  "Lexus|RZ 450E (2023 onwards)": "passenger",
  "Lexus|Sc430 (2001–2010)": "passenger",
  "Lexus|TX350 (2024 onwards)": "4wd",
  "Lexus|TX550H+ (2024 onwards)": "4wd",
  "Lexus|UX 200 (2019 onwards)": "passenger",
  "Lexus|UX 250H (2020 onwards)": "passenger",
  "Lexus|UX 300H (2024 onwards)": "passenger",
  "Lincoln|AVIATOR (2020 onwards)": "passenger",
  "Lincoln|CORSAIR (2020 onwards)": "passenger",
  "Lincoln|MKC (2015–2019)": "passenger",
  "Lincoln|MKX (2016–2018)": "passenger",
  "Lincoln|MKZ (2013–2020)": "passenger",
  "Lincoln|NAUTILUS (2019 onwards)": "passenger",
  "Lincoln|NAVIGATOR (2018 onwards)": "passenger",
  "Lincoln|Z (2022 onwards)": "passenger",
  "Maxus|eG10 (2016 onwards)": "mixed",
  "Maxus|G10 (2014 onwards)": "mixed",
  "Maxus|V80 (2014 onwards)": "mixed",
  "Mazda|5 (2011 onwards)": "passenger",
  "Mazda|6 GH (2008–2012)": "passenger",
  "Mazda|Biante (2013–2018)": "passenger",
  "Mazda|BT-50": "4wd",
  "Mazda|BT-50 TF": "4wd",
  "Mazda|Bt-50 TF / D-Max twin (2020–2024)": "4wd",
  "Mazda|Bt-50 TF facelift (2025 onwards)": "4wd",
  "Mazda|BT-50 UN": "4wd",
  "Mazda|Bt-50 UP (2012–2015)": "4wd",
  "Mazda|BT-50 UP/UR": "4wd",
  "Mazda|Bt-50 UR (2016–2019)": "4wd",
  "Mercedes-Benz|X-Class": "4wd",
  "Mercedes-Benz|X-Class (2018 onwards)": "4wd",
  "Mitsubishi|ASX": "4wd",
  "Mitsubishi|Asx (2024 onwards)": "4wd",
  "Mitsubishi|ATTRAGE (2015 onwards)": "passenger",
  "Mitsubishi|Challenger": "4wd",
  "Mitsubishi|Challenger (2008–2016)": "4wd",
  "Mitsubishi|Challenger PB & PC": "4wd",
  "Mitsubishi|COLT (2002–2013)": "passenger",
  "Mitsubishi|COLT (2023 onwards)": "passenger",
  "Mitsubishi|EXPRESS (2020 onwards)": "mixed",
  "Mitsubishi|L200": "4wd",
  "Mitsubishi|L200 (2005–2015)": "4wd",
  "Mitsubishi|L200 MQ-equiv (2016–2018)": "4wd",
  "Mitsubishi|L200 MR-equiv (2019–2023)": "4wd",
  "Mitsubishi|L200 MV-equiv (2024 onwards)": "4wd",
  "Mitsubishi|Mirage (2012–2016)": "passenger",
  "Mitsubishi|Mirage (2017 onwards)": "passenger",
  "Mitsubishi|Montero": "4wd",
  "Mitsubishi|Montero (2006 onwards)": "4wd",
  "Mitsubishi|Outlander": "4wd",
  "Mitsubishi|Outlander 2022+": "4wd",
  "Mitsubishi|Outlander 4th gen (2022 onwards)": "4wd",
  "Mitsubishi|Pajero NS/NT (2006–2011)": "4wd",
  "Mitsubishi|Pajero NW/NX (2011–2021)": "4wd",
  "Mitsubishi|Pajero NX": "4wd",
  "Mitsubishi|Pajero Sport": "4wd",
  "Mitsubishi|Pajero Sport PB": "4wd",
  "Mitsubishi|Pajero sport Pb (2008–2016)": "4wd",
  "Mitsubishi|Pajero sport QE (2015–2019)": "4wd",
  "Mitsubishi|Pajero sport QE facelift / QF (2020 onwards)": "4wd",
  "Mitsubishi|Pajero V80": "4wd",
  "Mitsubishi|Shogun": "4wd",
  "Mitsubishi|Shogun (2006 onwards)": "4wd",
  "Mitsubishi|Strada": "4wd",
  "Mitsubishi|Strada (2005–2015)": "4wd",
  "Mitsubishi|Strada MQ-equiv (2016–2018)": "4wd",
  "Mitsubishi|Strada MR-equiv (2019–2023)": "4wd",
  "Mitsubishi|Strada MV-equiv (2024 onwards)": "4wd",
  "Mitsubishi|Triton": "4wd",
  "Mitsubishi|Triton ML (2005–2009)": "4wd",
  "Mitsubishi|Triton ML/MN": "4wd",
  "Mitsubishi|Triton MN (2009–2015)": "4wd",
  "Mitsubishi|Triton MQ (2016–2018)": "4wd",
  "Mitsubishi|Triton MQ/MR": "4wd",
  "Mitsubishi|Triton MR (2019–2023)": "4wd",
  "Mitsubishi|Triton MV": "4wd",
  "Mitsubishi|Triton MV (2024 onwards)": "4wd",
  "Mitsubishi|Xpander": "passenger",
  "Mitsubishi|Xpander (2017 onwards)": "passenger",
  "Nissan|Almera (2000 onwards)": "passenger",
  "Nissan|Altima (2006 onwards)": "passenger",
  "Nissan|Caravan (2001 onwards)": "mixed",
  "Nissan|Cube Z11 (2005)": "passenger",
  "Nissan|Dualis (2006–2014)": "passenger",
  "Nissan|E25 (2001–2012)": "passenger",
  "Nissan|ELGRAND E52 (2010 onwards)": "passenger",
  "Nissan|Frontier (2004 onwards)": "4wd",
  "Nissan|Geniss (2006–2019)": "passenger",
  "Nissan|GT-R (2007 onwards)": "passenger",
  "Nissan|JUKE (2011 onwards)": "passenger",
  "Nissan|KICKS (2016 onwards)": "passenger",
  "Nissan|Lannia (2015 onwards)": "passenger",
  "Nissan|Latio (2012–2019)": "passenger",
  "Nissan|Leaf (2011 onwards)": "passenger",
  "Nissan|Livina (2006–2019)": "passenger",
  "Nissan|Livina (2020 onwards)": "passenger",
  "Nissan|March (2001 onwards)": "passenger",
  "Nissan|Maxima (2004–2014)": "passenger",
  "Nissan|Micra (2001 onwards)": "passenger",
  "Nissan|Murano": "4wd",
  "Nissan|Murano (2009 onwards)": "4wd",
  "Nissan|MX6 (2009 onwards)": "passenger",
  "Nissan|Navara D22 YD25": "4wd",
  "Nissan|Navara D23 MY21 (2021 onwards)": "4wd",
  "Nissan|Navara D23/NP300 (2015–2020)": "4wd",
  "Nissan|Navara D40": "4wd",
  "Nissan|Navara D40 early (2005–2009)": "4wd",
  "Nissan|Navara D40 Series II (2010–2015)": "4wd",
  "Nissan|Navara D40 Spanish": "4wd",
  "Nissan|Navara D40 Thai": "4wd",
  "Nissan|Navara NP300": "4wd",
  "Nissan|Navara YD25": "4wd",
  "Nissan|Note (2004 onwards)": "passenger",
  "Nissan|NP300 NP300 (2015–2020)": "4wd",
  "Nissan|NP300 NP300 MY21 (2021 onwards)": "4wd",
  "Nissan|NV200 (2010 onwards)": "mixed",
  "Nissan|NV350 (all years)": "mixed",
  "Nissan|Pathfinder": "4wd",
  "Nissan|Pathfinder (2005–2012)": "4wd",
  "Nissan|Pathfinder (2013 onwards)": "4wd",
  "Nissan|Pathfinder R51": "4wd",
  "Nissan|Pathfinder R52": "4wd",
  "Nissan|Patrol GU Series 4": "4wd",
  "Nissan|Patrol Y61 GU": "4wd",
  "Nissan|Patrol Y61 ZD30": "4wd",
  "Nissan|Patrol Y61/GU (2007 onwards)": "4wd",
  "Nissan|Patrol Y62": "4wd",
  "Nissan|Patrol Y62 (2013–2019)": "4wd",
  "Nissan|Patrol Y62 Series 5+ (2019 onwards)": "4wd",
  "Nissan|Patrol Y62 ST-L/TI": "4wd",
  "Nissan|Patrol Y62 TI-LW": "4wd",
  "Nissan|Prarie (1998–2004)": "passenger",
  "Nissan|Pulsar (2000 onwards)": "passenger",
  "Nissan|Qashqai (2006 onwards)": "passenger",
  "Nissan|Sentra (2000 onwards)": "passenger",
  "Nissan|Sunny (2000 onwards)": "passenger",
  "Nissan|Sylphy (2000 onwards)": "passenger",
  "Nissan|Teana J31 (2003–2008)": "passenger",
  "Nissan|Teana J32 (2008–2013)": "passenger",
  "Nissan|Terra": "4wd",
  "Nissan|Terra (2018 onwards)": "4wd",
  "Nissan|Tiida C11/C12/C13 (2004 onwards)": "passenger",
  "Nissan|Titan": "4wd",
  "Nissan|Titan A61 (2016 onwards)": "4wd",
  "Nissan|Titan xd (2016 onwards)": "4wd",
  "Nissan|Townstar (2022 onwards)": "passenger",
  "Nissan|Townstar E-Tech (2024 onwards)": "passenger",
  "Nissan|Urvan (2001 onwards)": "mixed",
  "Nissan|VENUCIA (2010 onwards)": "passenger",
  "Nissan|Versa (2006 onwards)": "passenger",
  "Nissan|Versa Note (2013 onwards)": "passenger",
  "Nissan|X-Trail T31": "4wd",
  "Nissan|X-Trail T31 (2007–2013)": "4wd",
  "Nissan|X-Trail T32": "4wd",
  "Nissan|X-Trail T32 (2014 onwards)": "4wd",
  "Nissan|Xterra": "4wd",
  "Nissan|Xterra (2005–2015)": "4wd",
  "Opel/Vauxhall|ADAM (2013 onwards)": "passenger",
  "Opel/Vauxhall|Agila (2000–2014)": "passenger",
  "Opel/Vauxhall|AMPERA (2012 onwards)": "passenger",
  "Opel/Vauxhall|Astra H/J/G (2000–2015)": "passenger",
  "Opel/Vauxhall|CASCADA (2013 onwards)": "passenger",
  "Opel/Vauxhall|Corsa (2000 onwards)": "passenger",
  "Opel/Vauxhall|GT (2007–2010)": "passenger",
  "Opel/Vauxhall|Insignia (2008 onwards)": "passenger",
  "Opel/Vauxhall|Meriva (2003–2017)": "passenger",
  "Opel/Vauxhall|Signum (2003–2008)": "passenger",
  "Opel/Vauxhall|Tigra (2004–2009)": "passenger",
  "Opel/Vauxhall|Vectra (2002–2008)": "passenger",
  "Opel/Vauxhall|Zafira (2005 onwards)": "passenger",
  "Porsche|Cayenne": "4wd",
  "Porsche|Cayenne (2002 onwards)": "4wd",
  "Proton|PERODUA AXIA (all years)": "passenger",
  "RAM|1500 5.7L Hemi": "4wd",
  "Renault|Arkana (2020 onwards)": "passenger",
  "Renault|Captur (2013 onwards)": "passenger",
  "Renault|CLio III / iv / v (2005 onwards)": "passenger",
  "Renault|Espace (2004 onwards)": "passenger",
  "Renault|Kangoo (2020 onwards)": "passenger",
  "Renault|Kangoo E-Tech (2022 onwards)": "passenger",
  "Renault|Koleos (2007 onwards)": "4wd",
  "Renault|Laguna III (2007–2015)": "passenger",
  "Renault|LATITUDE (2010 onwards)": "passenger",
  "Renault|Master (2010 onwards)": "mixed",
  "Renault|Megane (2002 onwards)": "passenger",
  "Renault|Scenic (2003 onwards)": "passenger",
  "Renault|Talisman (2015 onwards)": "passenger",
  "Renault|TRAFIC (2020 onwards)": "mixed",
  "Saab|All Models (2005–2011)": "passenger",
  "Scion|Ia (2013 onwards)": "passenger",
  "Scion|Im (2012 onwards)": "passenger",
  "Scion|Iq (2011–2016)": "passenger",
  "Scion|Tc (2005–2016)": "passenger",
  "Scion|Xb (2007–2015)": "passenger",
  "Scion|Xd (2007–2014)": "passenger",
  "Seat|Alhambra (2000–2010)": "passenger",
  "Seat|Cordoba (2002–2009)": "passenger",
  "Seat|Exeo (2008–2013)": "passenger",
  "Seat|Ibiza (2002–2017)": "passenger",
  "Seat|Leon (1998–2005)": "passenger",
  "Seat|Toledo (1998–2004)": "passenger",
  "Skoda|Fabia (1999–2014)": "passenger",
  "Skoda|Octavia (2000–2010)": "passenger",
  "Skoda|Superb (2001–2008)": "passenger",
  "Smart|FORFOUR (up to 2007)": "passenger",
  "Subaru|Forester": "4wd",
  "Subaru|Outback": "4wd",
  "Subaru|R1 (2005–2010)": "passenger",
  "Subaru|R2 (2005–2010)": "passenger",
  "Subaru|XV": "4wd",
  "Suzuki|Alivio (2014 onwards)": "passenger",
  "Suzuki|Carry (2013 onwards)": "passenger",
  "Suzuki|Ciaz (2014 onwards)": "passenger",
  "Suzuki|Equator (2008–2012)": "passenger",
  "Suzuki|Ertiga (2012–2018)": "passenger",
  "Suzuki|Grand Vitara": "4wd",
  "Suzuki|Grand vitara (2005 onwards)": "4wd",
  "Suzuki|Jimny": "4wd",
  "Suzuki|Jimny SN413": "4wd",
  "Suzuki|Jimny SN413 & JB74": "4wd",
  "Suzuki|KIZASHI (2013)": "passenger",
  "Suzuki|LIANA (2005 onwards)": "passenger",
  "Suzuki|S-CROSS (2013 onwards)": "4wd",
  "Suzuki|Solio (2008 onwards)": "passenger",
  "Suzuki|SPLASH (2008 onwards)": "passenger",
  "Suzuki|Swift (2004–2017)": "passenger",
  "Suzuki|Swift Sport (2005–2011)": "passenger",
  "Suzuki|Swift Sport (2012–2018)": "passenger",
  "Suzuki|Sx4 (2006 onwards)": "4wd",
  "Suzuki|Vitara": "4wd",
  "Suzuki|Vitara (2005 onwards)": "4wd",
  "Toyota|4Runner N210": "4wd",
  "Toyota|4Runner N210 (2002–2009)": "4wd",
  "Toyota|4Runner N280": "4wd",
  "Toyota|4Runner N280 (2009 onwards)": "4wd",
  "Toyota|AGYA (2013 onwards)": "passenger",
  "Toyota|Alphard (2002–2008)": "passenger",
  "Toyota|Alphard (2009 onwards)": "passenger",
  "Toyota|Altis (2006 onwards)": "passenger",
  "Toyota|Aurion (2006 onwards)": "passenger",
  "Toyota|Auris (2006 onwards)": "passenger",
  "Toyota|AVANZA (2004–2011)": "passenger",
  "Toyota|AVANZA (2012 onwards)": "passenger",
  "Toyota|Avensis (2003–2008)": "passenger",
  "Toyota|Avensis (2009–2018)": "passenger",
  "Toyota|Axio (2006 onwards)": "passenger",
  "Toyota|Aygo (2015 onwards)": "passenger",
  "Toyota|Aygo X (2022 onwards)": "passenger",
  "Toyota|Belta (2006–2016)": "passenger",
  "Toyota|Blade (2006 onwards)": "passenger",
  "Toyota|C-HR": "passenger",
  "Toyota|C-HR AX10 (2019–2024)": "passenger",

  "Toyota|Camry Xv30 (2001–2006)": "passenger",
  "Toyota|Camry XV40 (2006–2009)": "passenger",
  "Toyota|Camry XV40 (2009–2011)": "passenger",
  "Toyota|Camry XV50 (2011–2015)": "passenger",
  "Toyota|Camry XV50 (2015–2017)": "passenger",
  "Toyota|Camry XV70 (2017–2021)": "passenger",
  "Toyota|Camry XV70 (2021 onwards)": "passenger",
  "Toyota|CH-R AX10 early (2016–2019)": "passenger",
  "Toyota|CH-R AX10 facelift (2019 onwards)": "passenger",
  "Toyota|Corolla (2007–2012)": "passenger",
  "Toyota|Corolla Cross": "4wd",
  "Toyota|Corolla Cross gen1 (2022 onwards)": "4wd",
  "Toyota|Corolla E140/E150 (2007–2012)": "passenger",
  "Toyota|Corolla E210 (2018–2022)": "passenger",
  "Toyota|Corolla E210 (2023 onwards)": "passenger",
  "Toyota|Corolla (2018–2022)": "passenger",
  "Toyota|Corolla (2023 onwards)": "passenger",
  "Toyota|Corolla Hatch (2012–2018)": "passenger",
  "Toyota|Corolla Hatch E180 (2012–2018)": "passenger",
  "Toyota|Corolla Sedan (2014–2019)": "passenger",
  "Toyota|Corolla Sedan E170 (2014–2019)": "passenger",
  "Toyota|Corolla Verso (2005–2008)": "passenger",
  "Toyota|Corolla Verso (2009–2016)": "passenger",
  "Toyota|Crown S180 (2003–2008)": "passenger",
  "Toyota|Crown S200/S220/S210 (2008 onwards)": "passenger",
  "Toyota|Estima (2000–2006)": "passenger",
  "Toyota|Estima Xr50 (2006 onwards)": "passenger",
  "Toyota|Fielder (2006 onwards)": "passenger",
  "Toyota|FJ Cruiser": "4wd",
  "Toyota|Fj cruiser (2006 onwards)": "4wd",
  "Toyota|Fortuner": "4wd",
  "Toyota|Fortuner AN150": "4wd",
  "Toyota|Fortuner AN150/AN160 (2015–2020)": "4wd",
  "Toyota|Fortuner AN150/AN160 (2020 onwards)": "4wd",
  "Toyota|Fortuner AN50": "4wd",
  "Toyota|Fortuner AN50/AN60 (2005–2015)": "4wd",
  "Toyota|Granvia": "passenger",
  "Toyota|Granvia (2019 onwards)": "passenger",
  "Toyota|HARRIER (2013 onwards)": "4wd",
  "Toyota|HiAce": "4wd",
  "Toyota|Hiace COMMUTER (all years)": "mixed",
  "Toyota|HiAce H200": "4wd",
  "Toyota|Hiace H200 (2004–2019)": "mixed",
  "Toyota|HiAce H300": "4wd",
  "Toyota|Hiace H300 (2019 onwards)": "mixed",
  "Toyota|Highlander": "4wd",
  "Toyota|HIGHLANDER (2007 onwards)": "4wd",
  "Toyota|Hilux N70": "4wd",
  "Toyota|Hilux N70 (2005–2011)": "4wd",
  "Toyota|Hilux N70 (2011–2015)": "4wd",
  "Toyota|Hilux N70-pre / 5-pin (2000–2004)": "4wd",
  "Toyota|Hilux N80": "4wd",
  "Toyota|Hilux N80 (2015–2018)": "4wd",
  "Toyota|Hilux N80 (2018–2020)": "4wd",
  "Toyota|Hilux N80 (2020–2024)": "4wd",
  "Toyota|Hilux N80 (2024 onwards)": "4wd",
  "Toyota|Innova An140 (2015 onwards)": "passenger",
  "Toyota|Innova An40 (2004–2015)": "passenger",
  "Toyota|IQ (2008 onwards)": "passenger",
  "Toyota|Ist (2007–2016)": "passenger",
  "Toyota|Kluger": "4wd",
  "Toyota|Kluger (2000–2007)": "4wd",
  "Toyota|Kluger XU40 (2007–2010)": "4wd",
  "Toyota|Kluger XU40 (2010–2013)": "4wd",
  "Toyota|Kluger XU50 (2014–2017)": "4wd",
  "Toyota|Kluger XU50 (2017–2020)": "4wd",
  "Toyota|Kluger XU70 (2021 onwards)": "4wd",
  "Toyota|Land cruiser 100 SERIES V8 (2000 onwards)": "4wd",
  "Toyota|Land cruiser 100 SERIES with 5-pin pedal plug (2000 onwards)": "4wd",
  "Toyota|Land cruiser 70 Series (VDJ76/78/79) (2007–2009)": "4wd",
  "Toyota|Land cruiser 70 Series (VDJ76/78/79) (2009 onwards)": "4wd",
  "Toyota|Land cruiser LC200 (2007–2012)": "4wd",
  "Toyota|Land cruiser LC200 (2012–2015)": "4wd",
  "Toyota|Land cruiser LC200 (2015–2021)": "4wd",
  "Toyota|Land cruiser LC300 (2021 onwards)": "4wd",
  "Toyota|LandCruiser 100": "4wd",
  "Toyota|LandCruiser 200": "4wd",
  "Toyota|LandCruiser 300": "4wd",
  "Toyota|LandCruiser 70 Pre-09": "4wd",
  "Toyota|LandCruiser 70 Series": "4wd",
  "Toyota|LandCruiser 80": "4wd",
  "Toyota|Mark x X120 (2004–2009)": "passenger",
  "Toyota|Mark x X130 (2009–2019)": "passenger",
  "Toyota|Matrix (2003–2008)": "passenger",
  "Toyota|Matrix (2009–2014)": "passenger",
  "Toyota|Noah (2014 onwards)": "passenger",
  "Toyota|Picnic (2001–2009)": "passenger",
  "Toyota|Prado 120": "4wd",
  "Toyota|Prado 150": "4wd",
  "Toyota|Prado J120": "4wd",
  "Toyota|Prado J120 (2002–2006)": "4wd",
  "Toyota|Prado J120 (2006–2009)": "4wd",
  "Toyota|Prado J150": "4wd",
  "Toyota|Prado J150 (2009–2013)": "4wd",
  "Toyota|Prado J150 (2013–2015)": "4wd",
  "Toyota|Prado J150 (2015–2017)": "4wd",
  "Toyota|Prado J150 (2017–2021)": "4wd",
  "Toyota|Prado J150 (2021–2023)": "4wd",
  "Toyota|Previa (2006 onwards)": "passenger",
  "Toyota|Prius (2004–2009)": "passenger",
  "Toyota|Prius (2010 onwards)": "passenger",
  "Toyota|Raize (2011 onwards)": "passenger",
  "Toyota|RAV4": "4wd",
  "Toyota|Rav4 XA30 (2006–2008)": "4wd",
  "Toyota|Rav4 XA30 (2008–2012)": "4wd",
  "Toyota|Rav4 XA40 (2013–2015)": "4wd",
  "Toyota|Rav4 XA40 (2015–2018)": "4wd",
  "Toyota|Rav4 XA50 (2019 onwards)": "4wd",
  "Toyota|REIZ (2004–2009)": "passenger",
  "Toyota|Rukus (2007–2015)": "passenger",
  "Toyota|RUSH (2006 onwards)": "passenger",
  "Toyota|Sequoia": "4wd",
  "Toyota|Sequqia (2007 onwards)": "4wd",
  "Toyota|Sienna (2010 onwards)": "passenger",
  "Toyota|SIENTA (2015 onwards)": "passenger",
  "Toyota|Tacoma": "4wd",
  "Toyota|Tacoma (2005 onwards)": "4wd",
  "Toyota|Tarago (2006 onwards)": "passenger",
  "Toyota|Tundra": "4wd",
  "Toyota|Tundra (2003–2006)": "4wd",
  "Toyota|Tundra (2007 onwards)": "4wd",
  "Toyota|Urban cruiser (2007–2016)": "passenger",
  "Toyota|Vellfire (2008 onwards)": "passenger",
  "Toyota|Verso (2009–2018)": "passenger",
  "Toyota|Vios (2007 onwards)": "passenger",
  "Toyota|Vitz (2005 onwards)": "passenger",
  "Toyota|Voxy (2014 onwards)": "passenger",
  "Toyota|Wish Ae10 (2003–2009)": "passenger",
  "Toyota|Wish Ae20 (2010–2017)": "passenger",
  "Toyota|Yaris XP130 (2011–2014)": "passenger",
  "Toyota|Yaris XP130 Series II (2014–2017)": "passenger",
  "Toyota|Yaris XP130 Series III (2017–2020)": "passenger",
  "Toyota|Yaris XP210 (2020 onwards)": "passenger",
  "Toyota|Yaris XP90 (2005–2008)": "passenger",
  "Toyota|Yaris XP90 (2008–2011)": "passenger",
  "Volkswagen|Amarok": "4wd",
  "Volkswagen|Amarok (2023 onwards)": "4wd",
  "Volkswagen|Amarok 1st gen early (2011–2016)": "4wd",
  "Volkswagen|Amarok 1st gen facelift (2016–2022)": "4wd",
  "Volkswagen|Amarok 2H": "4wd",
  "Volkswagen|Amarok NF": "4wd",
  "Volkswagen|Beetle (1998–2011)": "passenger",
  "Volkswagen|Bora (1999–2005)": "passenger",
  "Volkswagen|FOX (2005 onwards)": "passenger",
  "Volkswagen|Golf (1997–2003)": "passenger",
  "Volkswagen|Jetta A5 (2006–2011)": "passenger",
  "Volkswagen|Lavida 1St Gen (2008–2013)": "passenger",
  "Volkswagen|Lupo (1998–2005)": "passenger",
  "Volkswagen|Multivan (2023 onwards)": "passenger",
  "Volkswagen|Passat B5/B5.5Typ 3B/3Bg (1997–2006)": "passenger",
  "Volkswagen|Phaeton (2002–2006)": "passenger",
  "Volkswagen|Polo Typ 6Q/9N/9N34Th Gen (2002–2009)": "passenger",
  "Volkswagen|SANTANA (2000–2012)": "passenger",
  "Volkswagen|Sharan Mark1A/1B (2000–2010)": "passenger",
  "Volkswagen|T5 (2009–2015)": "mixed",
  "Volkswagen|T5 Multivan (2009–2015)": "mixed",
  "Volkswagen|T6 (2015 onwards)": "mixed",
  "Volkswagen|Tiguan": "4wd",
  "Volkswagen|Touareg": "4wd",
  "Volkswagen|Touareg (2002–2018)": "4wd",
  "Volkswagen|Transporter (2009 onwards)": "mixed"
};

function vfIsPerformanceMode() {
  try {
    if (document.body && document.body.classList.contains('roar-performance')) return true;
    var h = (location.hostname || '').toLowerCase();
    if (h === 'roarperformance.com.au' || h === 'www.roarperformance.com.au') return true;
    // myshopify preview of Performance theme
    if (h.indexOf('myshopify.com') !== -1 && document.body && document.body.classList.contains('roar-performance')) return true;
  } catch (e) {}
  return false;
}

function vfDriveClass(vehicleKey) {
  if (VF_DRIVE_CLASS[vehicleKey]) return VF_DRIVE_CLASS[vehicleKey];
  // Heuristic fallback from model name
  var m = (vehicleKey.split('|')[1] || '').toLowerCase();
  var four = ['ranger','raptor','hilux','landcruiser','land cruiser','prado','patrol','navara','triton','pajero','d-max','dmax','bt-50','bt50','amarok','jimny','bronco','everest','mux','mu-x','fortuner','fj cruiser','gladiator','wrangler','cannon','tank','silverado','sierra','ram ','colorado','transporter','sprinter'];
  for (var i = 0; i < four.length; i++) {
    if (m.indexOf(four[i]) !== -1) return '4wd';
  }
  return 'passenger';
}

function vfAllowAccessories(vehicleKey) {
  // Yusuf/Samson LOCK: Performance host only — passenger/non-4WD → TC only.
  // roar4x4 (non-Performance) keeps full catalogue incl. Universal accessories.
  // 4WD/mixed on Performance → Universal 4WD Accessories OK.
  if (!vfIsPerformanceMode()) return true;
  var d = vfDriveClass(vehicleKey);
  return d === '4wd' || d === 'mixed';
}

var TC_HANDLES = vfIsPerformanceMode() ? TC_HANDLES_PERF : TC_HANDLES_4X4;


// ═══════════════════════════════════════════════════════════════
// VEHICLE-SPECIFIC PRODUCTS (Snorkels, Airboxes, Combos, Racks, etc.)
// ═══════════════════════════════════════════════════════════════
const VEHICLE_PRODUCTS = {
  "Ford|Ranger Next Gen": {
    snorkels: ["roar-4x4-snorkel-ford-ranger-nextgen", "roar-4x4-stainless-steel-snorkel-ford-next-gen-ranger"],
    airboxes: ["roar-4x4-airbox-ford-ranger-nextgen", "roar-4x4-aluminium-airbox-ford-next-gen-ranger"],
    combos: ["roar-4x4-combo-ford-next-gen-ranger-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-ford-next-gen-ranger", "roar-4x4-roof-rack-ford-ranger-nextgen"]
  },
  "Ford|Raptor": {
    snorkels: ["roar-4x4-snorkel-ford-raptor-nextgen", "roar-4x4-stainless-steel-snorkel-ford-next-gen-raptor"],
    airboxes: ["roar-4x4-airbox-ford-raptor-nextgen", "roar-4x4-aluminium-airbox-ford-next-gen-raptor"],
    combos: ["roar-4x4-combo-ford-next-gen-raptor-kit-1", "roar-4x4-combo-ford-next-gen-raptor-kit-2"]
  },
  "Ford|Ranger PX3": {
    snorkels: ["roar-4x4-stainless-steel-snorkel-ford-ranger-px3-px4", "ford-ranger-px2-px3-stainless-snorkel-kit-2015-2022-matte-black-4x4-snorkel"],
    airboxes: ["roar-4x4-airbox-ford-ranger-px2-px3", "roar-4x4-aluminium-airbox-ford-ranger-px3-px4"],
    combos: ["ford-ranger-px2-px3-snorkel-throttle-controller-combo-2015-2022-899-4x4-performance-deal", "roar-4x4-combo-ford-ranger-px2-px3-kit-2"]
  },
  "Ford|Ranger PX2": {
    snorkels: ["ford-ranger-px2-px3-stainless-snorkel-kit-2015-2022-matte-black-4x4-snorkel", "roar-4x4-stainless-steel-snorkel-ford-ranger-px3-px4"],
    airboxes: ["roar-4x4-airbox-ford-ranger-px2-px3", "roar-4x4-aluminium-airbox-ford-ranger-px3-px4"],
    combos: ["ford-ranger-px2-px3-snorkel-throttle-controller-combo-2015-2022-899-4x4-performance-deal", "roar-4x4-combo-ford-ranger-px2-px3-kit-2"]
  },
  "Ford|Ranger Raptor": {
    snorkels: ["roar-4x4-snorkel-ford-raptor-px3", "roar-4x4-stainless-steel-snorkel-ford-raptor-ranger"],
    airboxes: ["roar-4x4-airbox-ford-raptor-px3", "roar-4x4-aluminium-airbox-ford-raptor-ranger"],
    combos: ["roar-4x4-combo-ford-raptor-px3-kit-1", "roar-4x4-combo-ford-raptor-px3-kit-2"]
  },
  "GWM|Cannon": {
    snorkels: ["roar-4x4-snorkel-gwm-cannon", "roar-4x4-stainless-steel-snorkel-gwm-cannon"],
    airboxes: ["roar-4x4-airbox-gwm-cannon", "roar-4x4-aluminium-airbox-gwm-cannon"],
    combos: ["roar-4x4-combo-gwm-cannon-kit-1", "roar-4x4-combo-gwm-cannon-kit-2"]
  },
  "Isuzu|D-Max RG": {
    snorkels: ["roar-4x4-snorkel-isuzu-dmax", "roar-4x4-stainless-steel-snorkel-isuzu-d-max-rg"],
    airboxes: ["roar-4x4-airbox-isuzu-dmax", "roar-4x4-aluminium-airbox-isuzu-d-max-rg"],
    combos: ["roar-4x4-combo-isuzu-d-max-rg-kit-1", "roar-4x4-combo-isuzu-d-max-rg-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-isuzu-dmax-2021-2024", "roar-4x4-roof-rack-isuzu-dmax-2021"]
  },
  "Isuzu|D-Max TF": {
    roofRacks: ["roar-4x4-roof-rack-isuzu-dmax-2016-2020", "roar-4x4-roof-rack-isuzu-dmax-2016"]
  },
  "LDV|T60": {
    snorkels: ["roar-4x4-snorkel-ldv-t60", "roar-4x4-stainless-steel-snorkel-ldv-t60"],
    airboxes: ["roar-4x4-airbox-ldv-t60", "roar-4x4-aluminium-airbox-ldv-t60"],
    combos: ["roar-4x4-combo-ldv-t60-kit-1", "roar-4x4-combo-ldv-t60-kit-2"]
  },
  "Mazda|BT-50 TF": {
    snorkels: ["roar-4x4-snorkel-mazda-bt50", "roar-4x4-stainless-steel-snorkel-mazda-bt-50-tf"],
    airboxes: ["roar-4x4-airbox-mazda-bt50", "roar-4x4-aluminium-airbox-mazda-bt-50-tf"],
    combos: ["roar-4x4-combo-mazda-bt-50-tf-kit-1", "roar-4x4-combo-mazda-bt-50-tf-kit-2"]
  },
  "Mazda|BT-50": {
    snorkels: ["roar-4x4-snorkel-mazda-bt50", "roar-4x4-stainless-steel-snorkel-mazda-bt-50-tf"],
    airboxes: ["roar-4x4-airbox-mazda-bt50", "roar-4x4-aluminium-airbox-mazda-bt-50-tf"],
    combos: ["roar-4x4-combo-mazda-bt-50-tf-kit-1", "roar-4x4-combo-mazda-bt-50-tf-kit-2"]
  },
  "Mitsubishi|Pajero Sport": {
    snorkels: ["roar-4x4-snorkel-mitsubishi-pajero-sport", "roar-4x4-stainless-steel-snorkel-mitsubishi-pajero-sport"],
    airboxes: ["roar-4x4-airbox-mitsubishi-pajero-sport", "roar-4x4-aluminium-airbox-mitsubishi-pajero-sport"],
    combos: ["roar-4x4-combo-mitsubishi-pajero-sport-qe-qf-kit-1", "roar-4x4-combo-mitsubishi-pajero-sport-qe-qf-kit-2"]
  },
  "Mitsubishi|Pajero V80": {
    snorkels: ["roar-4x4-snorkel-mitsubishi-pajero", "roar-4x4-stainless-steel-snorkel-mitsubishi-pajero-v90"],
    airboxes: ["roar-4x4-airbox-mitsubishi-pajero", "roar-4x4-aluminium-airbox-mitsubishi-pajero-v90"],
    combos: ["roar-4x4-combo-mitsubishi-pajero-v90-kit-1", "roar-4x4-combo-mitsubishi-pajero-v90-kit-2"]
  },
  "Mitsubishi|Triton MQ/MR": {
    snorkels: ["roar-4x4-snorkel-mitsubishi-triton-mq", "roar-4x4-stainless-steel-snorkel-mitsubishi-triton-mq-mr"],
    airboxes: ["roar-4x4-airbox-mitsubishi-triton-mq", "roar-4x4-aluminium-airbox-mitsubishi-triton-mq-mr"],
    combos: ["roar-4x4-combo-mitsubishi-triton-mq-mr-kit-1", "roar-4x4-combo-mitsubishi-triton-mq-mr-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-mitsubishi-triton-2016-2023", "roar-4x4-roof-rack-mitsubishi-triton-mq"]
  },
  "Mitsubishi|Triton MV": {
    snorkels: ["roar-4x4-snorkel-mitsubishi-triton-mv", "roar-4x4-stainless-steel-snorkel-mitsubishi-triton-mv"],
    airboxes: ["roar-4x4-airbox-mitsubishi-triton-mv", "roar-4x4-aluminium-airbox-mitsubishi-triton-mv"],
    combos: ["roar-4x4-combo-mitsubishi-triton-mv-kit-1", "roar-4x4-combo-mitsubishi-triton-mv-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-mitsubishi-triton-2024", "roar-4x4-roof-rack-mitsubishi-triton-mv"]
  },
  "Nissan|Navara NP300": {
    snorkels: ["roar-4x4-snorkel-nissan-navara-np300", "roar-4x4-stainless-steel-snorkel-nissan-navara-np300"],
    airboxes: ["roar-4x4-airbox-nissan-navara-np300", "roar-4x4-aluminium-airbox-nissan-navara-np300"],
    combos: ["roar-4x4-combo-nissan-navara-np300-kit-1", "roar-4x4-combo-nissan-navara-np300-kit-2"]
  },
  "Nissan|Patrol Y61 GU": {
    snorkels: ["roar-4x4-snorkel-nissan-patrol-gu", "roar-4x4-stainless-steel-snorkel-nissan-patrol-gu-s4"],
    airboxes: ["roar-4x4-airbox-nissan-patrol-gu", "roar-4x4-aluminium-airbox-nissan-patrol-gu-s4"],
    combos: ["roar-4x4-combo-nissan-patrol-gu-s4-kit-1", "roar-4x4-combo-nissan-patrol-gu-s4-kit-2"]
  },
  "Nissan|Patrol GU Series 4": {
    snorkels: ["roar-4x4-snorkel-nissan-patrol-gu", "roar-4x4-stainless-steel-snorkel-nissan-patrol-gu-s4"],
    airboxes: ["roar-4x4-airbox-nissan-patrol-gu", "roar-4x4-aluminium-airbox-nissan-patrol-gu-s4"],
    combos: ["roar-4x4-combo-nissan-patrol-gu-s4-kit-1", "roar-4x4-combo-nissan-patrol-gu-s4-kit-2"]
  },
  "Nissan|Patrol Y62": {
    snorkels: ["roar-4x4-snorkel-nissan-patrol-y62", "roar-4x4-stainless-steel-snorkel-nissan-patrol-y62"],
    airboxes: ["roar-4x4-airbox-nissan-patrol-y62", "roar-4x4-aluminium-airbox-nissan-patrol-y62"],
    combos: ["roar-4x4-combo-nissan-patrol-y62-kit-1", "roar-4x4-combo-nissan-patrol-y62-kit-2"]
  },
  "Suzuki|Jimny": {
    snorkels: ["roar-4x4-snorkel-suzuki-jimny", "roar-4x4-stainless-steel-snorkel-suzuki-jimny"],
    airboxes: ["roar-4x4-airbox-suzuki-jimny", "roar-4x4-aluminium-airbox-suzuki-jimny"],
    combos: ["roar-4x4-combo-suzuki-jimny-kit-1", "roar-4x4-combo-suzuki-jimny-kit-2"]
  },
  "Suzuki|Jimny SN413": {
    snorkels: ["roar-4x4-snorkel-suzuki-jimny", "roar-4x4-stainless-steel-snorkel-suzuki-jimny"],
    airboxes: ["roar-4x4-airbox-suzuki-jimny", "roar-4x4-aluminium-airbox-suzuki-jimny"],
    combos: ["roar-4x4-combo-suzuki-jimny-kit-1", "roar-4x4-combo-suzuki-jimny-kit-2"]
  },
  "Suzuki|Jimny SN413 & JB74": {
    snorkels: ["roar-4x4-snorkel-suzuki-jimny", "roar-4x4-stainless-steel-snorkel-suzuki-jimny"],
    airboxes: ["roar-4x4-airbox-suzuki-jimny", "roar-4x4-aluminium-airbox-suzuki-jimny"],
    combos: ["roar-4x4-combo-suzuki-jimny-kit-1", "roar-4x4-combo-suzuki-jimny-kit-2"]
  },
  "Toyota|Hilux N70": {
    snorkels: ["roar-4x4-stainless-steel-snorkel-toyota-hilux-n70", "toyota-hilux-4-stainless-steel-snorkel-kit-to-fit-model-n70-7th-gen-04-05-07-11"],
    airboxes: ["roar-4x4-aluminium-airbox-toyota-hilux-n70", "toyota-hilux-aluminium-airbox-to-fit-model-n70-7th-gen-04-2005-08-2015"],
    combos: ["roar-4x4-combo-toyota-hilux-n70-kit-1", "roar-4x4-combo-toyota-hilux-n70-kit-2"]
  },
  "Toyota|Hilux N80": {
    snorkels: ["n80-stainless-snorkel-suits-hilux-7th-gen-09-2015-current", "toyota-hilux-n80-series-4-stainless-steel-snorkel-short-entry"],
    airboxes: ["roar-4x4-airbox-toyota-hilux-n80", "roar-4x4-aluminium-airbox-toyota-hilux-n80"],
    combos: ["roar-4x4-combo-toyota-hilux-n80-kit-1", "roar-4x4-combo-toyota-hilux-n80-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-toyota-hilux-n80", "roar-4x4-roof-rack-toyota-hilux-n80-1", "n80-roar-rack"],
    tonneauCovers: ["roar-4x4-tonneau-cover-hilux-n80"]
  },
  "Toyota|LandCruiser 200": {
    snorkels: ["roar-4x4-snorkel-toyota-landcruiser-200", "roar-4x4-stainless-steel-snorkel-toyota-landcruiser-200", "stainless-snorkel-kit-for-toyota-landcruiser-200-series-2008-2022"],
    airboxes: ["roar-4x4-airbox-toyota-landcruiser-200", "roar-4x4-aluminium-airbox-toyota-landcruiser-200"],
    combos: ["roar-4x4-combo-toyota-landcruiser-200-kit-1", "roar-4x4-combo-toyota-landcruiser-200-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-landcruiser-200", "roar-4x4-roof-rack-toyota-landcruiser-200"],
    sideBoxes: ["roar-4x4-side-storage-box-landcruiser-200"],
    sideLadders: ["roar-4x4-side-ladder-landcruiser-200"]
  },
  "Toyota|LandCruiser 300": {
    snorkels: ["roar-4x4-snorkel-toyota-landcruiser-300", "roar-4x4-stainless-steel-snorkel-toyota-landcruiser-300"],
    airboxes: ["roar-4x4-airbox-toyota-landcruiser-300", "roar-4x4-aluminium-airbox-toyota-landcruiser-300"],
    combos: ["roar-4x4-combo-toyota-landcruiser-300-kit-1", "roar-4x4-combo-toyota-landcruiser-300-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-landcruiser-300-factory-roof", "roar-4x4-roof-rack-landcruiser-300-long-bracket", "roar-4x4-roof-rack-toyota-landcruiser-300-a", "roar-4x4-roof-rack-toyota-landcruiser-300-b"],
    sideBoxes: ["roar-4x4-side-storage-box-landcruiser-300"],
    sideLadders: ["roar-4x4-side-ladder-landcruiser-300"]
  },
  "Toyota|LandCruiser 70 Series": {
    snorkels: ["roar-4x4-snorkel-toyota-landcruiser-70", "roar-4x4-stainless-steel-snorkel-toyota-landcruiser-76-79"],
    airboxes: ["roar-4x4-airbox-toyota-landcruiser-70", "roar-4x4-aluminium-airbox-toyota-landcruiser-76-79"],
    combos: ["roar-4x4-combo-toyota-landcruiser-76-79-kit-1", "roar-4x4-combo-toyota-landcruiser-76-79-kit-2"]
  },
  "Toyota|LandCruiser 70 Pre-09": {
    snorkels: ["roar-4x4-snorkel-toyota-landcruiser-70", "roar-4x4-stainless-steel-snorkel-toyota-landcruiser-76-79"],
    airboxes: ["roar-4x4-airbox-toyota-landcruiser-70", "roar-4x4-aluminium-airbox-toyota-landcruiser-76-79"],
    combos: ["roar-4x4-combo-toyota-landcruiser-76-79-kit-1", "roar-4x4-combo-toyota-landcruiser-76-79-kit-2"]
  },
  "Toyota|Prado J120": {
    snorkels: ["roar-4x4-snorkel-toyota-prado-120", "roar-4x4-stainless-steel-snorkel-toyota-prado-120"],
    airboxes: ["roar-4x4-airbox-toyota-prado-120", "roar-4x4-aluminium-airbox-toyota-prado-120"],
    combos: ["roar-4x4-combo-toyota-prado-120-kit-1", "roar-4x4-combo-toyota-prado-120-kit-2"]
  },
  "Toyota|Prado 120": {
    snorkels: ["roar-4x4-snorkel-toyota-prado-120", "roar-4x4-stainless-steel-snorkel-toyota-prado-120"],
    airboxes: ["roar-4x4-airbox-toyota-prado-120", "roar-4x4-aluminium-airbox-toyota-prado-120"],
    combos: ["roar-4x4-combo-toyota-prado-120-kit-1", "roar-4x4-combo-toyota-prado-120-kit-2"]
  },
  "Toyota|Prado J150": {
    snorkels: ["roar-4x4-snorkel-toyota-prado-150", "roar-4x4-stainless-steel-snorkel-toyota-prado-150"],
    airboxes: ["roar-4x4-airbox-toyota-prado-150", "roar-4x4-aluminium-airbox-toyota-prado-150"],
    combos: ["roar-4x4-combo-toyota-prado-150-kit-1", "roar-4x4-combo-toyota-prado-150-kit-2"]
  },
  "Toyota|Prado 150": {
    snorkels: ["roar-4x4-snorkel-toyota-prado-150", "roar-4x4-stainless-steel-snorkel-toyota-prado-150"],
    airboxes: ["roar-4x4-airbox-toyota-prado-150", "roar-4x4-aluminium-airbox-toyota-prado-150"],
    combos: ["roar-4x4-combo-toyota-prado-150-kit-1", "roar-4x4-combo-toyota-prado-150-kit-2"]
  },
  "Toyota|Prado 250": {
    snorkels: ["roar-4x4-snorkel-toyota-prado-250", "roar-4x4-stainless-steel-snorkel-toyota-prado-250"],
    airboxes: ["roar-4x4-airbox-toyota-prado-250", "roar-4x4-aluminium-airbox-toyota-prado-250"],
    combos: ["roar-4x4-combo-toyota-prado-250-kit-1", "roar-4x4-combo-toyota-prado-250-kit-2"],
    roofRacks: ["roar-4x4-roof-rack-prado-250-factory-roof", "roar-4x4-roof-rack-prado-250-long-bracket", "roar-4x4-roof-rack-prado-250-roof-mount", "roar-4x4-roof-rack-toyota-prado-250-large", "roar-4x4-roof-rack-toyota-prado-250-xl", "roar-4x4-roof-rack-toyota-prado-250-compact"],
    sideBoxes: ["roar-4x4-side-storage-box-prado-250"],
    sideLadders: ["roar-4x4-side-ladder-prado-250"]
  },
  "Volkswagen|Amarok": {
    snorkels: ["roar-4x4-snorkel-volkswagen-amarok", "roar-4x4-stainless-steel-snorkel-volkswagen-amarok-2h"],
    airboxes: ["roar-4x4-airbox-volkswagen-amarok", "roar-4x4-aluminium-airbox-volkswagen-amarok-2h"],
    combos: ["roar-4x4-combo-volkswagen-amarok-kit-1", "roar-4x4-combo-volkswagen-amarok-kit-2"]
  },
  "Volkswagen|Amarok 2H": {
    snorkels: ["roar-4x4-snorkel-volkswagen-amarok", "roar-4x4-stainless-steel-snorkel-volkswagen-amarok-2h"],
    airboxes: ["roar-4x4-airbox-volkswagen-amarok", "roar-4x4-aluminium-airbox-volkswagen-amarok-2h"],
    combos: ["roar-4x4-combo-volkswagen-amarok-kit-1", "roar-4x4-combo-volkswagen-amarok-kit-2"]
  },
  "Volkswagen|Amarok NF": {
    snorkels: ["roar-4x4-snorkel-volkswagen-amarok", "roar-4x4-stainless-steel-snorkel-volkswagen-amarok-2h"],
    airboxes: ["roar-4x4-airbox-volkswagen-amarok", "roar-4x4-aluminium-airbox-volkswagen-amarok-2h"],
    combos: ["roar-4x4-combo-volkswagen-amarok-kit-1", "roar-4x4-combo-volkswagen-amarok-kit-2"]
  }
};

// ═══════════════════════════════════════════════════════════════
// UNIVERSAL PRODUCTS (shown for ALL vehicles)
// ═══════════════════════════════════════════════════════════════
const UNIVERSAL_PRODUCTS = {
  waterTanks: [
    { handle: "roar4x4-15l-4wd-pressurised-water-tank-durable-aluminium-storage-for-off-roading", label: "15L Water Tank" },
    { handle: "roar4x4-26-litre-4wd-pressurised-water-tank-durable-aluminium-storage-for-off-roading", label: "26L Water Tank" },
    { handle: "roar4x4-35-litre-4wd-pressurised-water-tank-durable-aluminium-storage-for-off-roading", label: "35L Water Tank" },
    { handle: "roar4x4-57-litre-4wd-pressurised-water-tank-durable-aluminium-storage-for-off-roading", label: "57L Water Tank" },
    { handle: "roar-4x4-pressurised-water-tank-replacement-cap-with-built-in-relief-valve", label: "Replacement Cap" }
  ],
  accessories: [
    { handle: "roar-4x4-water-reel", label: "Water Reel" },
    { handle: "roar-4x4-air-tank", label: "Air Tank" },
    { handle: "roar-4x4-air-reel", label: "Air Reel" },
    { handle: "shower-head-roar-4x4", label: "Shower Accessory" },
    { handle: "roar-4x4-shovel-holder", label: "Shovel Holder" },
    { handle: "roar-4x4-truck-bed-drawer-slide-system", label: "Truck Bed Drawer System" },
    { handle: "roar-4x4-tub-rack-dual-cab-ute", label: "Tub Rack (Dual Cab)" },
    { handle: "roar-4x4-roof-rack-mount-tub-rack", label: "Roof Rack Mount for Tub Rack" },
    { handle: "roar-4x4-side-storage-box-tub-rack", label: "Side Storage Box for Tub Rack" },
    { handle: "roar-4x4-roof-tool-box-70l", label: "Roof Tool Box 70L" },
    { handle: "roar-4x4-roof-tool-box-90l", label: "Roof Tool Box 90L" },
    { handle: "roar-4x4-tool-box-mounting-board", label: "Tool Box Mounting Board" },
    { handle: "roar-4x4-tool-box-rackmount-bracket", label: "Tool Box Rackmount Bracket" },
    { handle: "roar-4x4-storage-bag-70l-tool-box", label: "Storage Bag for 70L Tool Box" },
    { handle: "roar-4x4-storage-bag-90l-tool-box", label: "Storage Bag for 90L Tool Box" }
  ],
  wheels: [
    { handle: "roar-4x4-dx005-17x9-off-road-alloy-wheel-set-of-4-6x139-7-pcd-et0-110-1cb-premium-fit-for-hilux-ranger-d-max-bt-50-triton-colorado-prado-navara", label: "DX005 17x9 Wheel Set (Matte Black)" },
    { handle: "roar-4x4-dx065-wheel-17x9-matte-black", label: "DX065 17x9 Wheel (Matte Black)" },
    { handle: "roar-4x4-dx189-wheel-17x9-bronze-black-ring", label: "DX189 17x9 Wheel (Bronze + Black)" },
    { handle: "roar-4x4-dx189-wheel-18x9-bronze-black-ring", label: "DX189 18x9 Wheel (Bronze + Black)" }
  ]
};

// Vehicles that fit 6x139.7 PCD wheels
const WHEEL_COMPATIBLE = [
  "Toyota|Hilux N70","Toyota|Hilux N80","Toyota|Prado J120","Toyota|Prado J150",
  "Toyota|Prado 120","Toyota|Prado 150","Toyota|LandCruiser 70 Series",
  "Toyota|Fortuner AN50","Toyota|Fortuner AN150","Toyota|FJ Cruiser",
  "Ford|Ranger PX1","Ford|Ranger PX2","Ford|Ranger PX3","Ford|Ranger Next Gen",
  "Ford|Ranger Raptor","Ford|Raptor","Ford|Ranger & Raptor",
  "Isuzu|D-Max","Isuzu|D-Max RC","Isuzu|D-Max TF","Isuzu|D-Max RG",
  "Isuzu|MU-X","Isuzu|MU-X RF","Isuzu|MU-X RJ","Isuzu|MUX",
  "Mazda|BT-50","Mazda|BT-50 TF","Mazda|BT-50 UN","Mazda|BT-50 UP/UR",
  "Mitsubishi|Triton ML/MN","Mitsubishi|Triton MQ/MR","Mitsubishi|Triton MV",
  "Holden|Colorado","Holden|Colorado RC","Holden|RG Colorado",
  "Nissan|Navara D40","Nissan|Navara NP300","Nissan|Navara D22 YD25",
  "GWM|Cannon","GWM|Cannon Alpha","GWM|Cannon NPW","Greatwall|Cannon",
  "Volkswagen|Amarok","Volkswagen|Amarok 2H"
];

// ═══════════════════════════════════════════════════════════════
// VEHICLE LIST for dropdown + search (Make → Models)
// ═══════════════════════════════════════════════════════════════
const VEHICLE_LIST = {};
Object.keys(TC_HANDLES).forEach(function(key) {
  var parts = key.split('|');
  var make = parts[0], model = parts[1];
  if (!VEHICLE_LIST[make]) VEHICLE_LIST[make] = [];
  if (VEHICLE_LIST[make].indexOf(model) === -1) VEHICLE_LIST[make].push(model);
});
// Add vehicles that only appear in VEHICLE_PRODUCTS
Object.keys(VEHICLE_PRODUCTS).forEach(function(key) {
  var parts = key.split('|');
  var make = parts[0], model = parts[1];
  if (!VEHICLE_LIST[make]) VEHICLE_LIST[make] = [];
  if (VEHICLE_LIST[make].indexOf(model) === -1) VEHICLE_LIST[make].push(model);
});
// Sort models
Object.keys(VEHICLE_LIST).forEach(function(make) {
  VEHICLE_LIST[make].sort();
});

// ═══════════════════════════════════════════════════════════════
// PRODUCT CACHE (fetched from Shopify AJAX API)
// ═══════════════════════════════════════════════════════════════
var productCache = {};

function fetchProduct(handle) {
  if (productCache[handle]) return Promise.resolve(productCache[handle]);
  return fetch('/products/' + handle + '.json')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (data && data.product) {
        productCache[handle] = data.product;
        return data.product;
      }
      return null;
    })
    .catch(function() { return null; });
}

// ═══════════════════════════════════════════════════════════════
// SEARCH ENGINE - Fuzzy text matching
// ═══════════════════════════════════════════════════════════════
function normalise(s) {
  return s.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
}

function fuzzyMatch(query, target) {
  var q = normalise(query);
  var t = normalise(target);
  if (t.indexOf(q) !== -1) return 100;
  var qWords = q.split(' ');
  var matched = 0;
  qWords.forEach(function(w) {
    if (t.indexOf(w) !== -1) matched++;
  });
  if (qWords.length > 0 && matched === qWords.length) return 90;
  if (matched > 0) return Math.round((matched / qWords.length) * 70);
  return 0;
}

function searchVehicles(query) {
  var results = [];
  Object.keys(VEHICLE_LIST).forEach(function(make) {
    VEHICLE_LIST[make].forEach(function(model) {
      var key = make + '|' + model;
      var searchStr = make + ' ' + model;
      var score = fuzzyMatch(query, searchStr);
      if (score > 30) {
        results.push({ key: key, make: make, model: model, score: score });
      }
    });
  });
  results.sort(function(a, b) { return b.score - a.score; });
  return results.slice(0, 15);
}

// ═══════════════════════════════════════════════════════════════
// PRODUCT RENDERING
// ═══════════════════════════════════════════════════════════════
function getProductsForVehicle(vehicleKey) {
  var products = [];
  var seen = {};

  function addHandle(handle, category) {
    if (seen[handle]) return;
    seen[handle] = true;
    products.push({ handle: handle, category: category });
  }

  // TC products
  var tcHandles = TC_HANDLES[vehicleKey] || [];
  tcHandles.forEach(function(h) { addHandle(h, 'Throttle Controller'); });

  // Vehicle-specific 4WD accessories — gated (passenger → TC only)
  if (vfAllowAccessories(vehicleKey)) {
    var vp = VEHICLE_PRODUCTS[vehicleKey];
    if (vp) {
      (vp.snorkels || []).forEach(function(h) { addHandle(h, 'Snorkel'); });
      (vp.airboxes || []).forEach(function(h) { addHandle(h, 'Airbox'); });
      (vp.combos || []).forEach(function(h) { addHandle(h, 'Combo Kit'); });
      (vp.roofRacks || []).forEach(function(h) { addHandle(h, 'Roof Rack'); });
      (vp.sideBoxes || []).forEach(function(h) { addHandle(h, 'Side Storage Box'); });
      (vp.sideLadders || []).forEach(function(h) { addHandle(h, 'Side Ladder'); });
      (vp.tonneauCovers || []).forEach(function(h) { addHandle(h, 'Tonneau Cover'); });
    }
    // Wheels (if compatible)
    if (WHEEL_COMPATIBLE.indexOf(vehicleKey) !== -1) {
      UNIVERSAL_PRODUCTS.wheels.forEach(function(w) { addHandle(w.handle, 'Wheels'); });
    }
  }

  return products;
}


// VIP display for cards: metafield map + type locks (mirror product.liquid). Prices not changed.
var ROAR_VIP_BY_HANDLE = {"throttle-controller-jeep-wrangler-jl-2018-2023":169.0,"throttle-controller-jeep-gladiator-2025-onwards":169.0,"throttle-controller-mitsubishi-pajero-sport-2015-2019":169.0,"throttle-controller-ford-puma-2020-onwards":169.0,"throttle-controller-mitsubishi-outlander-2022-onwards":169.0,"throttle-controller-toyota-kluger-xu70-2021-onwards":169.0,"throttle-controller-toyota-yaris-xp210-2020-onwards":169.0,"throttle-controller-lexus-nx-az10-2017-2022":169.0,"throttle-controller-toyota-kluger-xu40-2010-2014":169.0,"throttle-controller-lexus-nx-az20-2022-onwards":169.0,"throttle-controller-nissan-navara-d23-2015-2020":169.0,"throttle-controller-toyota-c-hr-ax10-2019-2024":169.0,"throttle-controller-holden-cruze-jh-2011-2016":169.0,"throttle-controller-holden-cruze-jg-2009-2011":169.0,"throttle-controller-ford-focus-lw-2011-2015":169.0,"throttle-controller-ford-focus-lz-2015-2018":169.0,"throttle-controller-ford-focus-sa-2018-2022":169.0,"throttle-controller-toyota-yaris-xp130-2011-2014":169.0,"throttle-controller-toyota-yaris-xp130-series-ii-2014-2017":169.0,"throttle-controller-toyota-yaris-xp130-series-iii-2017-2020":169.0,"throttle-controller-toyota-prado-j150-2021-2023":169.0,"throttle-controller-toyota-prado-j150-2013-2017":169.0,"throttle-controller-toyota-kluger-xu50-2017-2020":169.0,"throttle-controller-toyota-kluger-xu50-2014-2017":169.0,"throttle-controller-toyota-camry-xv70-2021-2024":169.0,"throttle-controller-toyota-camry-xv70-2017-2021":169.0,"throttle-controller-toyota-camry-xv50-2015-2017":169.0,"throttle-controller-toyota-camry-xv50-2011-2015":169.0,"throttle-controller-toyota-camry-xv40-2009-2011":169.0,"throttle-controller-mazda-bt-50-tf-2025-onwards":169.0,"throttle-controller-mazda-bt-50-tf-2020-2024":169.0,"throttle-controller-mazda-bt-50-ur-2015-2019":169.0,"throttle-controller-mazda-bt-50-up-2012-2015":169.0,"throttle-controller-toyota-prado-j150-2017-2021":169.0,"throttle-controller-toyota-prado-j150-2009-2013":169.0,"throttle-controller-isuzu-mu-x-2025-onwards":169.0,"throttle-controller-isuzu-mu-x-2021-2025":169.0,"throttle-controller-isuzu-mu-x-2017-2020":169.0,"throttle-controller-isuzu-mu-x-2013-2016":169.0,"roar-4x4-combo-toyota-hilux-n80-kit-2":1299,"toyota-hilux-n80-series-4-stainless-steel-snorkel-short-entry":799.0,"throttle-controller-suits-nissan-navara-d40-thai-spanish":169.0,"roar-throttle-controller-for-nissan-navara-np300":169.0,"toyota-hilux-n70-snorkel-airbox-combo-kit-2005-2015-roar-4x4-special-offer-1-999-free-throttle-controller-200-value":1299.0,"roar-4x4-throttle-controller-for-toyota-hilux-n70-2005-2015":169.0,"roar-4x4-toyota-hilux-n80-performance-throttle-controller-2015-current":169.0,"nissan-patrol-gu-series-4-throttle-controller-2004-2016-improve-throttle-response-and-4wd-performance":169.0,"n70-airbox-roar-4x4":1299.0,"throttle-controller-suits-ford-ranger-px1-px2-px3-roar-4x4":169.0,"throttle-controller-suits-next-gen-ford-raptor":169.0,"throttle-controller-suits-dmax-08-2020":169.0,"throttle-controller-suits-bt50-08-2020":169.0,"throttle-controller-suits-100-105-series-landcruiser":169.0,"throttle-controller-suits-80-series-landcruiser":169.0,"throttle-controller-suits-ml-mn-triton":169.0,"throttle-controller-suits-mv-triton":169.0,"isuzu-mux-throttle-controller-suits-2013-2025":169.0,"70-series-throttle-controller-suits-76-78-79-plug-and-play":169.0,"toyota-fortuner-2005-08-2015-throttle-controller-eliminate-throttle-lag-6-modes-ai-learning":169.0,"fj-cruiser-throttle-controller-suits-2011-2016-plug-and-play":169.0,"r51-pathfinder-throttle-controller-suits-2005-2013-plug-and-play":169.0,"mitsubishi-pajero-v80-2006-current-throttle-controller-plug-and-play-instant-pedal-response":169.0,"holden-rg-colorado-throttle-controller-2012-2020-plug-and-play-instant-pedal-response":169.0,"volkswagen-amarok-vw-nf-2023-current-throttle-controller-instant-response-plug-and-play":169.0,"throttle-controller-suits-jeep-grand-cherokee-wl-2022-current-6-modes-plug-and-play":169.0,"throttle-controller-suits-jeep-wrangler-jl-2018-current-improve-acceleration":169.0,"throttle-controller-suits-jeep-gladiator-jt-2020-current-off-road-throttle-control":169.0,"throttle-controller-suits-jeep-cherokee-kl-2014-current-plug-and-play-instant-pedal-response":169.0,"throttle-controller-suits-suzuki-jimny-sn413-and-jb74-1998-current-instant-pedal-response":169.0,"throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response":169.0,"throttle-controller-suits-ldv-t60-2017-2021-eliminate-pedal-lag":169.0,"throttle-controller-suits-gwm-cannon-npw-2020-2024-instant-pedal-response":169.0,"throttle-controller-suits-gwm-tank-300-2022-current":169.0,"throttle-controller-suits-mercedes-x-class-x220d-x250d-x350d-instant-pedal-response":169.0,"throttle-controller-suits-lexus-gx550-2024-current-instant-throttle-response":169.0,"throttle-controller-suits-lexus-lx600-2022-current-eliminate-throttle-lag":169.0,"throttle-controller-suits-lexus-lx570-2008-current-enhance-pedal-response":169.0,"throttle-controller-suits-lexus-gx460-2010-current-eliminate-throttle-lag":169.0,"n80-stainless-snorkel-suits-hilux-7th-gen-09-2015-current":799.0,"stainless-snorkel-kit-for-toyota-landcruiser-200-series-2008-2022":799.0,"toyota-hilux-n80-snorkel-throttle-controller-combo-2015-current-899-stainless-steel-4x4-upgrade":849.0,"toyota-landcruiser-200-series-snorkel-throttle-controller-combo-2008-2022-899-stainless-steel-4x4-upgrade":849.0,"toyota-hilux-n70-snorkel-throttle-controller-combo-2005-2015-899-stainless-steel-4x4-upgrade":849.0,"throttle-controller-ford-everest-ua-2015-2022":169.0,"throttle-controller-ford-everest-next-gen-2022-current":169.0,"throttle-controller-ford-ranger-pk-2009-2011":169.0,"throttle-controller-ford-ranger-pxi-2011-2015":169.0,"throttle-controller-ford-ranger-pxii-2015-2018":169.0,"throttle-controller-ford-ranger-pxiii-2018-2022":169.0,"throttle-controller-isuzu-dmax-rg-2020-current":169.0,"throttle-controller-isuzu-dmax-tf-2012-2020":169.0,"throttle-controller-isuzu-dmax-rc-2008-2012":169.0,"throttle-controller-isuzu-mux-rf-2013-2021":169.0,"throttle-controller-holden-colorado-rc-2008-2012":169.0,"throttle-controller-nissan-xtrail-t31-2007-2014":169.0,"throttle-controller-jeep-grand-cherokee-wk2-2011-2021":169.0,"throttle-controller-jeep-grand-cherokee-wk-2005-2010":169.0,"throttle-controller-land-rover-defender-110-2020-current":169.0,"throttle-controller-land-rover-defender-130-2022-current":169.0,"throttle-controller-volkswagen-amarok-2h-2010-2023":169.0,"throttle-controller-mazda-bt50-tf-2020-current":169.0,"throttle-controller-gwm-cannon-alpha-2024-current":169.0,"throttle-controller-gwm-tank-500-2023-current":169.0,"throttle-controller-ram-1500-57l-hemi":169.0,"throttle-controller-mitsubishi-outlander-2012-current":169.0,"throttle-controller-mitsubishi-pajero-nx-2016-2021":169.0,"throttle-controller-toyota-hiace-2019-current":169.0,"throttle-controller-suzuki-jimny-sn413-1998-2018":169.0,"throttle-controller-suzuki-grand-vitara-2005-2019":169.0,"throttle-controller-hyundai-iload-imax-2008-2021":169.0,"throttle-controller-subaru-forester-2012-current":169.0,"throttle-controller-chevrolet-silverado-2020-onwards":169.0,"roar-4x4-throttle-controller-chevrolet-silverado-2019-2022":169.0,"throttle-controller-dodge-ram-1500-2019-onwards":169.0,"throttle-controller-dodge-ram-2500-2019-onwards":169.0,"throttle-controller-ford-bronco-2020-onwards":169.0,"throttle-controller-ford-everest-2016-onwards":169.0,"throttle-controller-ford-everest-next-gen-2022-onwards":169.0,"throttle-controller-ford-f150-2009-onwards":169.0,"throttle-controller-ford-falcon-2008-2016":169.0,"throttle-controller-ford-ranger-next-gen-2022-onwards":169.0,"throttle-controller-ford-ranger-px1-2012-2015":169.0,"throttle-controller-ford-ranger-px2-2016-2018":169.0,"throttle-controller-ford-ranger-px3-2019-2022":169.0,"throttle-controller-ford-ranger-raptor-2018-onwards":169.0,"throttle-controller-ford-territory-2010-onwards":169.0,"throttle-controller-gmc-sierra-2020-onwards":169.0,"throttle-controller-gwm-cannon-2020-onwards":169.0,"throttle-controller-gwm-cannon-alpha-2024-onwards":169.0,"throttle-controller-gwm-tank-300-2022-onwards":169.0,"throttle-controller-gwm-tank-500-2022-onwards":169.0,"throttle-controller-gwm-ute-2022-onwards":169.0,"throttle-controller-greatwall-cannon-2020-onwards":169.0,"throttle-controller-haval-h9-2015-onwards":169.0,"throttle-controller-holden-colorado-2012-onwards":169.0,"throttle-controller-holden-trailblazer-2016-onwards":169.0,"throttle-controller-holden-trax-2013-2020":169.0,"throttle-controller-hummer-h3-2005-2010":169.0,"throttle-controller-hyundai-santa-fe-2012-onwards":169.0,"throttle-controller-hyundai-iload-2008-2021":169.0,"throttle-controller-hyundai-imax-2008-2021":169.0,"throttle-controller-ineos-grenadier-2023-onwards":169.0,"throttle-controller-isuzu-d-max-2012-onwards":169.0,"throttle-controller-isuzu-d-max-rc-2008-2012":169.0,"throttle-controller-isuzu-d-max-rg-2020-onwards":169.0,"throttle-controller-isuzu-d-max-tf-2012-2020":169.0,"throttle-controller-isuzu-mu-x-2012-onwards":169.0,"throttle-controller-isuzu-mu-x-rj-2021-onwards":169.0,"throttle-controller-jeep-cherokee-kl-2014-onwards":169.0,"throttle-controller-jeep-gladiator-2020-onwards":169.0,"throttle-controller-jeep-grand-cherokee-wl-2022-onwards":169.0,"throttle-controller-jeep-wrangler-jk-2006-2018":169.0,"throttle-controller-jeep-wrangler-jl-2018-onwards":169.0,"throttle-controller-kia-sorento-2015-onwards":169.0,"throttle-controller-kia-sportage-2021-onwards":169.0,"throttle-controller-ldv-d90-2017-onwards":169.0,"throttle-controller-ldv-t60-2017-onwards":169.0,"throttle-controller-land-rover-discovery-5-2017-onwards":169.0,"throttle-controller-lexus-gx-460-2010-onwards":169.0,"throttle-controller-lexus-gx-550-2024-onwards":169.0,"throttle-controller-lexus-lx-570-2008-onwards":169.0,"throttle-controller-lexus-lx-600-2022-onwards":169.0,"throttle-controller-mazda-bt-50-2020-onwards":169.0,"throttle-controller-mazda-bt-50-un-2006-2011":169.0,"throttle-controller-mazda-bt-50-up-ur-2011-2020":169.0,"throttle-controller-mercedes-benz-x-class-2018-2021":169.0,"throttle-controller-mitsubishi-challenger-2009-2015":169.0,"throttle-controller-mitsubishi-outlander-2022-2022-onwards":169.0,"throttle-controller-mitsubishi-pajero-sport-2015-onwards":169.0,"throttle-controller-mitsubishi-triton-ml-mn-2005-2015":169.0,"throttle-controller-nissan-navara-d22-yd25-2001-2006":169.0,"throttle-controller-nissan-navara-d40-2005-onwards":169.0,"throttle-controller-nissan-navara-d40-spanish-2005-2010":169.0,"throttle-controller-nissan-navara-d40-thai-2008-2015":169.0,"throttle-controller-nissan-navara-np300-2014-onwards":169.0,"throttle-controller-nissan-pathfinder-r51-2005-2013":169.0,"throttle-controller-nissan-pathfinder-r52-2013-onwards":169.0,"throttle-controller-nissan-patrol-y61-gu-2007-onwards":169.0,"throttle-controller-nissan-patrol-y61-zd30-2000-2006":169.0,"throttle-controller-nissan-patrol-y62-2010-onwards":169.0,"throttle-controller-nissan-x-trail-t32-2014-onwards":169.0,"throttle-controller-porsche-cayenne-2010-2018":169.0,"throttle-controller-ram-1500-57l-hemi-2019-onwards":169.0,"throttle-controller-subaru-forester-2008-onwards":169.0,"throttle-controller-subaru-outback-2009-onwards":169.0,"throttle-controller-subaru-xv-2017-onwards":169.0,"throttle-controller-suzuki-jimny-2018-onwards":169.0,"throttle-controller-toyota-4runner-n280-2009-onwards":169.0,"throttle-controller-toyota-c-hr-2016-onwards":169.0,"throttle-controller-toyota-corolla-cross-2022-onwards":169.0,"throttle-controller-toyota-corolla-2018-2022":169.0,"throttle-controller-toyota-corolla-2023-onwards":169.0,"throttle-controller-toyota-corolla-2007-2012":169.0,"throttle-controller-toyota-corolla-hatch-2012-2018":169.0,"throttle-controller-toyota-corolla-sedan-2014-2019":169.0,"throttle-controller-toyota-corolla-2018-onwards":169.0,"throttle-controller-toyota-fj-cruiser-2006-onwards":169.0,"throttle-controller-toyota-fortuner-an150-2016-onwards":169.0,"throttle-controller-toyota-fortuner-an50-2004-2015":169.0,"throttle-controller-toyota-hiace-2019-onwards":169.0,"throttle-controller-toyota-hilux-n70-2004-2015":169.0,"throttle-controller-toyota-kluger-2008-onwards":169.0,"throttle-controller-toyota-landcruiser-100-1998-2007":169.0,"throttle-controller-toyota-landcruiser-200-2007-onwards":169.0,"throttle-controller-toyota-landcruiser-300-2021-onwards":169.0,"throttle-controller-toyota-landcruiser-70-pre-09-2007-sep-2009":169.0,"throttle-controller-toyota-landcruiser-70-series-2009-onwards":169.0,"throttle-controller-toyota-landcruiser-80-1990-1998":169.0,"throttle-controller-toyota-prado-j120-2002-2009":169.0,"throttle-controller-toyota-prado-j150-2009-onwards":169.0,"throttle-controller-toyota-rav4-2005-onwards":169.0,"throttle-controller-volkswagen-amarok-2010-2022":169.0,"throttle-controller-volkswagen-amarok-nf-2023-onwards":169.0,"throttle-controller-volkswagen-tiguan-2008-onwards":169.0,"roar-4x4-stainless-steel-snorkel-ford-ranger-px3-px4":799.0,"roar-4x4-stainless-steel-snorkel-toyota-hilux-n70":799.0,"roar-4x4-stainless-steel-snorkel-volkswagen-amarok-2h":799.0,"roar-4x4-side-ladder-prado-250":469.0,"roar-4x4-side-ladder-landcruiser-300":469.0,"roar-4x4-side-ladder-landcruiser-200":469.0,"roar-4x4-side-storage-box-prado-250":355.0,"roar-4x4-side-storage-box-landcruiser-300":355.0,"roar-4x4-side-storage-box-landcruiser-200":355.0,"roar-4x4-tub-rack-dual-cab-ute":999.0,"roar-4x4-side-storage-box-tub-rack":599.0,"roar-4x4-roof-rack-mount-tub-rack":630.0,"roar-4x4-roof-tool-box-90l":432.0,"roar-4x4-roof-tool-box-70l":449.0,"roar-4x4-tool-box-rackmount-bracket":179.0,"roar-4x4-tool-box-mounting-board":125.0,"roar-4x4-storage-bag-90l-tool-box":99.0,"roar-4x4-storage-bag-70l-tool-box":109.0,"roar-4x4-tonneau-cover-hilux-n80":1875.0,"roar-4x4-snorkel-ford-ranger-nextgen":799.0,"roar-4x4-snorkel-ford-raptor-nextgen":799.0,"roar-4x4-snorkel-ford-raptor-px3":799.0,"roar-4x4-snorkel-gwm-cannon":799.0,"roar-4x4-snorkel-isuzu-dmax":799.0,"roar-4x4-snorkel-ldv-t60":799.0,"roar-4x4-snorkel-mazda-bt50":799.0,"roar-4x4-snorkel-mitsubishi-pajero":799.0,"roar-4x4-snorkel-mitsubishi-pajero-sport":799.0,"roar-4x4-snorkel-mitsubishi-triton-mq":799.0,"roar-4x4-snorkel-mitsubishi-triton-mv":799.0,"roar-4x4-snorkel-nissan-navara-np300":799.0,"roar-4x4-snorkel-nissan-patrol-gu":799.0,"roar-4x4-snorkel-nissan-patrol-y62":799.0,"roar-4x4-snorkel-suzuki-jimny":799.0,"roar-4x4-snorkel-toyota-prado-120":799.0,"roar-4x4-snorkel-toyota-prado-150":799.0,"roar-4x4-snorkel-toyota-prado-250":799.0,"roar-4x4-snorkel-toyota-landcruiser-70":799.0,"roar-4x4-snorkel-toyota-landcruiser-200":799.0,"roar-4x4-snorkel-toyota-landcruiser-300":799.0,"roar-4x4-snorkel-volkswagen-amarok":799.0,"roar-4x4-combo-ford-next-gen-raptor-kit-1":849.0,"roar-4x4-combo-ford-raptor-px3-kit-1":849.0,"roar-4x4-combo-gwm-cannon-kit-1":849.0,"roar-4x4-combo-isuzu-d-max-rg-kit-1":849.0,"roar-4x4-combo-ldv-t60-kit-1":849.0,"roar-4x4-combo-mazda-bt-50-tf-kit-1":849.0,"roar-4x4-combo-mitsubishi-pajero-v90-kit-1":849.0,"roar-4x4-combo-mitsubishi-pajero-sport-qe-qf-kit-1":849.0,"roar-4x4-combo-mitsubishi-triton-mq-mr-kit-1":849.0,"roar-4x4-combo-mitsubishi-triton-mv-kit-1":849.0,"roar-4x4-combo-nissan-navara-np300-kit-1":849.0,"roar-4x4-combo-nissan-patrol-gu-s4-kit-1":849.0,"roar-4x4-combo-nissan-patrol-y62-kit-1":849.0,"roar-4x4-combo-suzuki-jimny-kit-1":849.0,"roar-4x4-combo-toyota-hilux-n70-kit-1":849.0,"roar-4x4-combo-toyota-hilux-n70-kit-2":1299.0,"roar-4x4-combo-toyota-hilux-n80-kit-1":849.0,"roar-4x4-combo-toyota-prado-120-kit-1":849.0,"roar-4x4-combo-toyota-prado-150-kit-1":849.0,"roar-4x4-combo-toyota-prado-250-kit-1":849.0,"roar-4x4-combo-toyota-landcruiser-76-79-kit-1":849.0,"roar-4x4-combo-toyota-landcruiser-200-kit-1":849.0,"roar-4x4-combo-toyota-landcruiser-300-kit-1":849.0,"roar-4x4-combo-volkswagen-amarok-kit-1":849.0,"roar-4x4-throttle-controller-ford-everest-raptor":169.0,"roar-4x4-throttle-controller-ford-f150":169.0,"roar-4x4-throttle-controller-ford-ranger-nextgen-t6":169.0,"roar-4x4-throttle-controller-isuzu-mu-x":169.0,"roar-4x4-throttle-controller-mitsubishi-triton-2016-2018":169.0,"roar-4x4-throttle-controller-mitsubishi-triton-2019-2023":169.0,"roar-4x4-throttle-controller-mitsubishi-triton-2024-onwards":169.0,"roar-4x4-throttle-controller-suzuki-jimny":169.0,"roar-4x4-throttle-controller-toyota-fortuner-an150-an160":169.0,"roar-4x4-throttle-controller-toyota-rav4":169.0,"roar-4x4-throttle-controller-volkswagen-amarok":169.0,"roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards":169.0,"roar-4x4-throttle-controller-chevrolet-suburban":169.0,"roar-4x4-throttle-controller-chevrolet-tahoe":169.0,"roar-4x4-throttle-controller-dodge-ram-1500":169.0,"roar-4x4-throttle-controller-dodge-ram-1500-trx":169.0,"roar-4x4-throttle-controller-ford-bronco":169.0,"roar-4x4-throttle-controller-ford-explorer":169.0,"roar-4x4-throttle-controller-ford-f-150-raptor":169.0,"roar-4x4-throttle-controller-ford-f250":169.0,"roar-4x4-throttle-controller-ford-f350":169.0,"roar-4x4-throttle-controller-ford-maverick":169.0,"roar-4x4-throttle-controller-gmc-canyon":169.0,"roar-4x4-throttle-controller-gmc-sierra":169.0,"roar-4x4-throttle-controller-gmc-yukon":169.0,"roar-4x4-throttle-controller-gwm-cannon":169.0,"roar-4x4-throttle-controller-greatwall-cannon":169.0,"roar-4x4-throttle-controller-holden-trailblazer":169.0,"roar-4x4-throttle-controller-hummer-h3":169.0,"roar-4x4-throttle-controller-land-rover-discovery-sport":169.0,"roar-4x4-throttle-controller-land-rover-evoque":169.0,"roar-4x4-throttle-controller-land-rover-range-rover":169.0,"roar-4x4-throttle-controller-land-rover-range-rover-sport":169.0,"roar-4x4-throttle-controller-land-rover-range-rover-velar":169.0,"roar-4x4-throttle-controller-lexus-gx470":169.0,"roar-4x4-throttle-controller-mitsubishi-asx":169.0,"roar-4x4-throttle-controller-mitsubishi-montero":169.0,"roar-4x4-throttle-controller-mitsubishi-xpander":169.0,"roar-4x4-throttle-controller-nissan-murano":169.0,"roar-4x4-throttle-controller-nissan-terra":169.0,"roar-4x4-throttle-controller-nissan-titan":169.0,"roar-4x4-throttle-controller-nissan-xterra":169.0,"roar-4x4-throttle-controller-suzuki-grand-vitara":169.0,"roar-4x4-throttle-controller-suzuki-vitara":169.0,"roar-4x4-throttle-controller-toyota-4runner-n210":169.0,"roar-4x4-throttle-controller-toyota-4runner-n280":169.0,"roar-4x4-throttle-controller-toyota-granvia":169.0,"roar-4x4-throttle-controller-toyota-hiace-h200":169.0,"roar-4x4-throttle-controller-toyota-hiace-h300":169.0,"roar-4x4-throttle-controller-toyota-highlander":169.0,"roar-4x4-throttle-controller-toyota-sequoia":169.0,"roar-4x4-throttle-controller-volkswagen-touareg":169.0,"roar-4x4-throttle-controller-toyota-kluger-2000":169.0,"roar-4x4-throttle-controller-toyota-land-cruiser-vdj76-78-79-2007":169.0,"roar-4x4-throttle-controller-toyota-land-cruiser-vdj76-78-79-2009":169.0,"roar-4x4-throttle-controller-volkswagen-amarok-2010":169.0,"roar-4x4-throttle-controller-volkswagen-amarok-2023":169.0,"roar-4x4-throttle-controller-mitsubishi-l200-2016":169.0,"roar-4x4-throttle-controller-toyota-tacoma-2005-plug-567":169.0,"roar-4x4-throttle-controller-toyota-tundra-2003":169.0,"roar-4x4-throttle-controller-toyota-hilux-n70":169.0,"roar-4x4-throttle-controller-toyota-hilux-n80-2015-2018":169.0,"roar-4x4-throttle-controller-toyota-hilux-n80-2018-2020":169.0,"roar-4x4-throttle-controller-toyota-hilux-n80-2020-onwards":169.0,"roar-4x4-throttle-controller-toyota-prado-j120":169.0,"roar-4x4-throttle-controller-toyota-prado-j150":169.0,"roar-4x4-throttle-controller-toyota-landcruiser-300":169.0,"roar-4x4-throttle-controller-mazda-bt-50-up-ur":169.0,"roar-4x4-throttle-controller-mazda-bt-50-tf":169.0,"roar-4x4-throttle-controller-haval-h9":169.0,"roar-4x4-throttle-controller-jmc-vigus":169.0,"roar-4x4-throttle-controller-ldv-d90":169.0,"roar-4x4-throttle-controller-ldv-t60":169.0,"roar-4x4-throttle-controller-maxus-t60":169.0,"roar-4x4-throttle-controller-jeep-cherokee-kl":169.0,"roar-4x4-throttle-controller-jeep-gladiator":169.0,"roar-4x4-throttle-controller-jeep-grand-cherokee-wk2":169.0,"roar-4x4-throttle-controller-jeep-wrangler-jk":169.0,"roar-4x4-throttle-controller-jeep-wrangler-jl":169.0,"roar-4x4-throttle-controller-ford-f-150":169.0,"roar-4x4-throttle-controller-ford-ranger-px1":169.0,"roar-4x4-throttle-controller-toyota-fj-cruiser":169.0,"roar-4x4-throttle-controller-toyota-landcruiser-100":169.0,"roar-4x4-throttle-controller-toyota-landcruiser-200-early":169.0,"roar-4x4-throttle-controller-ford-ranger-px2":169.0,"roar-4x4-throttle-controller-ford-ranger-px3":169.0,"throttle-controller-ford-everest-ua-2016-2022":169.0,"roar-4x4-throttle-controller-ford-raptor-px3":169.0,"roar-4x4-throttle-controller-holden-colorado-rg":169.0,"roar-4x4-throttle-controller-holden-colorado-7":169.0,"roar-4x4-throttle-controller-isuzu-d-max-2008-2012":169.0,"roar-4x4-throttle-controller-isuzu-mu-x-2013-2020":169.0,"roar-4x4-throttle-controller-ford-raptor-nextgen":169.0,"roar-4x4-throttle-controller-ford-everest-nextgen":169.0,"roar-4x4-throttle-controller-isuzu-d-max-rg":169.0,"roar-4x4-throttle-controller-isuzu-mu-x-2021":169.0,"roar-4x4-throttle-controller-hino-300-series":169.0,"roar-4x4-throttle-controller-land-rover-defender":169.0,"roar-4x4-throttle-controller-land-rover-defender-130":169.0,"roar-4x4-throttle-controller-land-rover-discovery-4":169.0,"roar-4x4-throttle-controller-land-rover-discovery-5":169.0,"roar-4x4-throttle-controller-lexus-gx460":169.0,"roar-4x4-throttle-controller-lexus-gx550h":169.0,"roar-4x4-throttle-controller-lexus-lx570":169.0,"roar-4x4-throttle-controller-mercedes-benz-x-class":169.0,"roar-4x4-throttle-controller-mitsubishi-outlander":169.0,"roar-4x4-throttle-controller-mitsubishi-pajero-nx":169.0,"roar-4x4-throttle-controller-mitsubishi-pajero-sport":169.0,"roar-4x4-throttle-controller-mitsubishi-triton-ml-mn":169.0,"roar-4x4-throttle-controller-nissan-navara-d23-np300":169.0,"roar-4x4-throttle-controller-nissan-navara-d40":169.0,"roar-4x4-throttle-controller-nissan-pathfinder-r52":169.0,"throttle-controller-nissan-patrol-y61-gu-crd-2007-2016":169.0,"roar-4x4-throttle-controller-nissan-patrol-y62":169.0,"roar-4x4-throttle-controller-nissan-x-trail-t32":169.0,"roar-4x4-throttle-controller-porsche-cayenne":169.0,"roar-4x4-throttle-controller-toyota-landcruiser-200":169.0};
function roarVipDollars(p) {
  if (!p) return null;
  var handle = p.handle || '';
  if (Object.prototype.hasOwnProperty.call(ROAR_VIP_BY_HANDLE, handle)) {
    var mf = ROAR_VIP_BY_HANDLE[handle];
    if (mf != null && !isNaN(mf) && mf > 0) return Math.round(mf);
  }
  var price = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : NaN;
  if (isNaN(price)) return null;
  var type = (p.type || '').toLowerCase();
  var title = (p.title || '').toLowerCase();
  var hay = type + ' ' + title + ' ' + handle.toLowerCase();
  var hasSnorkel = hay.indexOf('snorkel') !== -1;
  var hasAirbox = hay.indexOf('airbox') !== -1 || hay.indexOf('air box') !== -1;
  var isCombo = type.indexOf('combo') !== -1 || hay.indexOf('combo') !== -1 || (hasSnorkel && hasAirbox) || (hay.indexOf('throttle') !== -1 && (hasSnorkel || hasAirbox));
  if (isCombo) return null;
  if (type.indexOf('throttle') !== -1 && !hasSnorkel && !hasAirbox) return Math.round(price - 60);
  if ((type.indexOf('roof rack') !== -1 || type === 'roof racks') && type.indexOf('accessor') === -1) return 999;
  if (type.indexOf('snorkel') !== -1 || hasSnorkel) return 799;
  if (type.indexOf('airbox') !== -1 || type.indexOf('air box') !== -1 || hasAirbox) return 899;
  return null;
}
function roarPriceHtml(priceStr, vipDollars) {
  var rrp = parseFloat(priceStr);
  if (isNaN(rrp)) return '';
  var rrpTxt = '$' + Math.round(rrp);
  // Throttle controllers: $60 off applies to every buyer (Oct 2026). Never imply joining is needed for $169.
  if (Math.round(rrp) === 229 && vipDollars != null && Math.round(vipDollars) === 169) {
    return '<div class="vf-product-price"><span class="vip">Special $169</span> <span class="roar-normally">normally $229</span></div>';
  }
  if (vipDollars != null && vipDollars > 0 && vipDollars < rrp) {
    return '<div class="vf-product-price"><span class="rrp">' + rrpTxt + '</span> <span class="vip">VIP $' + Math.round(vipDollars) + '</span></div>';
  }
  return '<div class="vf-product-price"><span class="rrp">' + rrpTxt + '</span></div>';
}

function renderProductCard(product, container) {
  fetchProduct(product.handle).then(function(p) {
    if (!p) return;
    var img = (p.images && p.images.length > 0) ? p.images[0].src : '';
    var price = p.variants && p.variants[0] ? p.variants[0].price : '';
    var card = document.createElement('a');
    card.href = '/products/' + product.handle;
    card.className = 'vf-product-card';
    card.innerHTML =
      '<div class="vf-product-img">' +
        (img ? '<img src="' + img.replace(/\.([a-z]+)\?/, '_300x.$1?') + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '<div class="vf-no-img">No Image</div>') +
        '<span class="vf-cat-tag">' + escHtml(product.category) + '</span>' +
      '</div>' +
      '<div class="vf-product-body">' +
        '<h4>' + escHtml(p.title.replace(/ \| Roar 4X4.*$/, '').replace(/ – ROAR.*$/, '').replace(/ \| Plug.*$/, '').replace(/ \| Instant.*$/, '').replace(/ \| Eliminate.*$/, '').replace(/ \| Improve.*$/, '').replace(/ \| Boost.*$/, '').replace(/ \| Off-Road.*$/, '').replace(/ \| 6 Modes.*$/, '')) + '</h4>' +
        roarPriceHtml(price, roarVipDollars(p)) +
      '</div>';
    container.appendChild(card);
  });
}

function renderUniversalProducts(container) {
  var section = document.createElement('div');
  section.className = 'vf-universal-section vf-allow-accessories';
  section.innerHTML = '<h3 class="vf-section-title">Universal 4WD Accessories</h3><p class="vf-section-sub">These products fit all vehicles</p><div class="vf-product-grid vf-universal-grid"></div>';
  container.appendChild(section);
  var grid = section.querySelector('.vf-universal-grid');

  var allUniversal = UNIVERSAL_PRODUCTS.waterTanks.concat(UNIVERSAL_PRODUCTS.accessories);
  allUniversal.forEach(function(item) {
    fetchProduct(item.handle).then(function(p) {
      if (!p) return;
      var img = (p.images && p.images.length > 0) ? p.images[0].src : '';
      var price = p.variants && p.variants[0] ? p.variants[0].price : '';
      var card = document.createElement('a');
      card.href = '/products/' + item.handle;
      card.className = 'vf-product-card vf-product-card-sm';
      card.innerHTML =
        '<div class="vf-product-img">' +
          (img ? '<img src="' + img.replace(/\.([a-z]+)\?/, '_200x.$1?') + '" alt="' + escHtml(item.label) + '" loading="lazy">' : '<div class="vf-no-img">No Image</div>') +
        '</div>' +
        '<div class="vf-product-body">' +
          '<h4>' + escHtml(item.label) + '</h4>' +
          roarPriceHtml(price, roarVipDollars(p)) +
        '</div>';
      grid.appendChild(card);
    });
  });
}

function escHtml(s) {
  var d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

// ═══════════════════════════════════════════════════════════════
// DISPLAY RESULTS for a vehicle key
// ═══════════════════════════════════════════════════════════════
function showResults(vehicleKey) {
  var parts = vehicleKey.split('|');
  var make = parts[0], model = parts[1];
  var resultsDiv = document.getElementById('vfResults');
  if (!resultsDiv) return;

  resultsDiv.innerHTML =
    '<div class="vf-results-header">' +
      '<h3>Products for <span class="vf-accent">' + escHtml(make + ' ' + model) + '</span></h3>' +
      '<button class="vf-clear-btn" onclick="window.vfClearResults()">Clear Results</button>' +
    '</div>' +
    '<div class="vf-product-grid" id="vfProductGrid"></div>' +
    '<div id="vfUniversalArea"></div>';
  resultsDiv.classList.add('show');

  var grid = document.getElementById('vfProductGrid');
  var products = getProductsForVehicle(vehicleKey);

  if (products.length === 0) {
    grid.innerHTML = vfAllowAccessories(vehicleKey)
      ? '<div class="vf-no-results">No vehicle-specific products found. Check out our universal accessories below.</div>'
      : '<div class="vf-no-results">No throttle controller match found for this vehicle.</div>';
  } else {
    products.forEach(function(prod) {
      renderProductCard(prod, grid);
    });
  }

  // Universal 4WD accessories only when selected vehicle is 4WD/mixed
  if (vfAllowAccessories(vehicleKey)) {
    renderUniversalProducts(document.getElementById('vfUniversalArea'));
  }

  resultsDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

window.vfClearResults = function() {
  var r = document.getElementById('vfResults');
  if (r) { r.innerHTML = ''; r.classList.remove('show'); }
  var suggestions = document.getElementById('vfSuggestions');
  if (suggestions) suggestions.innerHTML = '';
};

// ═══════════════════════════════════════════════════════════════
// MODE 1: TEXT SEARCH
// ═══════════════════════════════════════════════════════════════
function initTextSearch() {
  var input = document.getElementById('vfSearchInput');
  var suggestions = document.getElementById('vfSuggestions');
  if (!input || !suggestions) return;

  var debounceTimer;
  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      var q = input.value.trim();
      if (q.length < 2) { suggestions.innerHTML = ''; return; }
      var matches = searchVehicles(q);
      if (matches.length === 0) {
        suggestions.innerHTML = '<div class="vf-suggestion-item vf-no-match">No vehicles found for "' + escHtml(q) + '"</div>';
        return;
      }
      suggestions.innerHTML = matches.map(function(m) {
        var productCount = (TC_HANDLES[m.key] || []).length;
        var vp = VEHICLE_PRODUCTS[m.key];
        if (vp) {
          productCount += (vp.snorkels || []).length + (vp.airboxes || []).length +
            (vp.combos || []).length + (vp.roofRacks || []).length;
        }
        return '<div class="vf-suggestion-item" data-key="' + escHtml(m.key) + '">' +
          '<strong>' + escHtml(m.make) + '</strong> ' + escHtml(m.model) +
          '<span class="vf-product-count">' + productCount + ' product' + (productCount !== 1 ? 's' : '') + '</span>' +
        '</div>';
      }).join('');

      suggestions.querySelectorAll('.vf-suggestion-item[data-key]').forEach(function(el) {
        el.addEventListener('click', function() {
          showResults(el.getAttribute('data-key'));
          suggestions.innerHTML = '';
          input.value = el.querySelector('strong').textContent + ' ' + el.textContent.replace(el.querySelector('strong').textContent, '').replace(/\d+ products?/, '').trim();
        });
      });
    }, 200);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      var first = suggestions.querySelector('.vf-suggestion-item[data-key]');
      if (first) first.click();
    }
  });
}

// ═══════════════════════════════════════════════════════════════
// MODE 2: PHOTO AI IDENTIFICATION
// ═══════════════════════════════════════════════════════════════
function initPhotoMode() {
  var dropZone = document.getElementById('vfPhotoZone');
  var fileInput = document.getElementById('vfPhotoInput');
  var preview = document.getElementById('vfPhotoPreview');
  if (!dropZone || !fileInput) return;

  dropZone.addEventListener('click', function() { fileInput.click(); });
  dropZone.addEventListener('dragover', function(e) { e.preventDefault(); dropZone.classList.add('drag-over'); });
  dropZone.addEventListener('dragleave', function() { dropZone.classList.remove('drag-over'); });
  dropZone.addEventListener('drop', function(e) {
    e.preventDefault(); dropZone.classList.remove('drag-over');
    if (e.dataTransfer.files.length > 0) handlePhoto(e.dataTransfer.files[0]);
  });
  fileInput.addEventListener('change', function() {
    if (fileInput.files.length > 0) handlePhoto(fileInput.files[0]);
  });
}

function handlePhoto(file) {
  if (!file.type.startsWith('image/')) {
    alert('Please upload an image file (JPG, PNG, etc.)');
    return;
  }

  var preview = document.getElementById('vfPhotoPreview');
  var statusDiv = document.getElementById('vfPhotoStatus');
  var reader = new FileReader();
  reader.onload = function(e) {
    var base64 = e.target.result;
    preview.innerHTML = '<img src="' + base64 + '" alt="Uploaded vehicle photo">';
    preview.classList.add('show');
    statusDiv.innerHTML = '<div class="vf-ai-loading"><div class="vf-spinner"></div> Identifying your vehicle...</div>';
    statusDiv.classList.add('show');
    identifyVehicle(base64, file.type);
  };
  reader.readAsDataURL(file);
}

function identifyVehicle(base64Data, mediaType) {
  var statusDiv = document.getElementById('vfPhotoStatus');
  var imageData = base64Data.split(',')[1];
  var mType = mediaType || 'image/jpeg';

  fetch(AI_PROXY_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      model: 'claude-sonnet-4-20250514',
      max_tokens: 300,
      messages: [{
        role: 'user',
        content: [
          { type: 'image', source: { type: 'base64', media_type: mType, data: imageData } },
          { type: 'text', text: 'Identify this vehicle. Return ONLY a JSON object with "make" and "model" fields. For Australian market 4x4s and utes, use these exact model names where applicable: Hilux N70, Hilux N80, Ranger PX1, Ranger PX2, Ranger PX3, Ranger Next Gen, LandCruiser 200, LandCruiser 300, LandCruiser 70 Series, Prado J120, Prado J150, Patrol Y62, Patrol Y61 GU, D-Max RG, Triton MQ/MR, BT-50 TF, Navara NP300. If you cannot identify the vehicle, return {"make":"unknown","model":"unknown"}.' }
        ]
      }]
    })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    var text = data.content && data.content[0] ? data.content[0].text : '';
    var jsonMatch = text.match(/\{[\s\S]*?\}/);
    if (!jsonMatch) throw new Error('No JSON in response');
    var vehicle = JSON.parse(jsonMatch[0]);

    if (!vehicle.make || vehicle.make === 'unknown') {
      statusDiv.innerHTML = '<div class="vf-ai-result vf-ai-error">Could not identify the vehicle. Try a clearer photo or use the text search instead.</div>';
      return;
    }

    // Tork Governance: log compliance receipt for AI photo analysis
    if (window.TorkGovernance) {
        window.TorkGovernance.generateReceipt('photo_identification', { redactions: [] }, 'ALLOW');
    }

    var query = vehicle.make + ' ' + vehicle.model;
    var matches = searchVehicles(query);

    if (matches.length > 0) {
      statusDiv.innerHTML =
        '<div class="vf-ai-result">' +
          '<div class="vf-ai-detected">Detected: <strong>' + escHtml(vehicle.make + ' ' + vehicle.model) + '</strong></div>' +
          '<div class="vf-ai-matches">' +
            '<p>Select the best match:</p>' +
            matches.slice(0, 5).map(function(m) {
              return '<button class="vf-ai-match-btn" data-key="' + escHtml(m.key) + '">' + escHtml(m.make + ' ' + m.model) + '</button>';
            }).join('') +
          '</div>' +
        '</div>';
      statusDiv.querySelectorAll('.vf-ai-match-btn').forEach(function(btn) {
        btn.addEventListener('click', function() { showResults(btn.getAttribute('data-key')); });
      });
    } else {
      statusDiv.innerHTML = '<div class="vf-ai-result vf-ai-error">Detected <strong>' + escHtml(vehicle.make + ' ' + vehicle.model) + '</strong> but no matching products found. Try the text search.</div>';
    }
  })
  .catch(function(err) {
    statusDiv.innerHTML = '<div class="vf-ai-result vf-ai-error">Photo identification is currently unavailable. Please use the text search or dropdown instead.</div>';
  });
}

// ═══════════════════════════════════════════════════════════════
// MODE 3: DROPDOWN BROWSE
// ═══════════════════════════════════════════════════════════════
function initDropdown() {
  var makeSelect = document.getElementById('vfMake');
  var modelSelect = document.getElementById('vfModel');
  var searchBtn = document.getElementById('vfDropdownBtn');
  if (!makeSelect || !modelSelect) return;

  var makes = Object.keys(VEHICLE_LIST).sort();
  makes.forEach(function(make) {
    var opt = document.createElement('option');
    opt.value = make; opt.textContent = make;
    makeSelect.appendChild(opt);
  });

  makeSelect.addEventListener('change', function() {
    modelSelect.innerHTML = '<option value="">Select Model...</option>';
    modelSelect.disabled = !makeSelect.value;
    if (searchBtn) searchBtn.disabled = true;
    if (!makeSelect.value) return;
    var models = VEHICLE_LIST[makeSelect.value] || [];
    models.forEach(function(model) {
      var opt = document.createElement('option');
      opt.value = model; opt.textContent = model;
      modelSelect.appendChild(opt);
    });
  });

  modelSelect.addEventListener('change', function() {
    if (searchBtn) searchBtn.disabled = !modelSelect.value;
  });

  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      if (makeSelect.value && modelSelect.value) {
        showResults(makeSelect.value + '|' + modelSelect.value);
      }
    });
  }
}

// ═══════════════════════════════════════════════════════════════
// TAB SWITCHING
// ═══════════════════════════════════════════════════════════════
function initTabs() {
  document.querySelectorAll('.vf-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.vf-tab').forEach(function(t) { t.classList.remove('active'); });
      document.querySelectorAll('.vf-tab-content').forEach(function(c) { c.classList.remove('active'); });
      tab.classList.add('active');
      var target = document.getElementById(tab.getAttribute('data-tab'));
      if (target) target.classList.add('active');
    });
  });
}

// ═══════════════════════════════════════════════════════════════
// INIT
// ═══════════════════════════════════════════════════════════════
function init() {
  initTabs();
  initTextSearch();
  initPhotoMode();
  initDropdown();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})();
